/* Gemaakt op 2026-06-06 09:58 CEST - 3-fase hartmaatcorrecties aangepast naar 5 cm */
/* assets/rail-configurator-v3.js
   Rail configurator – Worker-only (opgeschoond)
   - Tekenen + segment inputs + add-to-cart + export PDF (download via Worker)
   - Alle berekeningen via Cloudflare Worker (/solve)
   - Shareable link via ?cfg=...
   - Mobile + desktop duplicate action bars supported (A)
*/
(function () {
  'use strict';

  const root = document.querySelector('[data-railcfg]');
  if (!root) return;

  // ---------------------------
  // Config + DOM
  // ---------------------------
  const WORKER_BASE = (root.dataset.workerBaseUrl || '').trim().replace(/\/+$/, '');

  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => Array.from(root.querySelectorAll(sel));

  const el = {
    workerUrl: $('[data-worker-url]'),
    svg: $('[data-svg]'),
    partsBody: $('[data-parts]'),
    partsWrap: $('[data-parts-wrap]'),
    summary: $('[data-summary]'),

    // Buttons can exist twice (desktop + mobile) => arrays
    btnUndo: $$('[data-undo]'),
    btnClear: $$('[data-clear]'),
    btnPickPower: $$('[data-pick-power]'),
    btnClearPower: $$('[data-clear-power]'),
    btnAddCart: $$('[data-add-cart]'),
    btnOffer: $('[data-offer-btn]'),
    offerPanel: $('[data-offer-panel]'),
    offerForm: $('[id="RailcfgOfferForm"]'),
    offerSubmit: $('[data-offer-submit]'),
    offerDesignCode: $('[data-offer-design-code]'),
    offerFormMsg: $('[data-offer-form-msg]'),
    btnLocks: $$('[data-lock]'),
    btnFinishDraw: $$('[data-finish-draw]'),

    goCart: $('[data-go-cart]'),
    cartMsg: $('[data-cart-msg]'),
    designMsg: $('[data-design-msg]'),

    segTableBody: $('[data-segtable]'),
    cutPlan: $('[data-cutplan]'),
    cutPlanWrap: $('[data-cutplan-content]'),
    cutPlanToggle: $('[data-cutplan-toggle]'),
    cutPlanBlock: $('[data-cutplan-block]'),
    confidenceBlock: $('[data-confidence-block]'),

    colorBtns: $$('[data-color]'),
    colorName: $('[data-color-name]'),
    statusText: $('[data-status-text]'),
    configAlert: $('[data-config-alert]'),
    stepItems: $$('[data-step-index]'),

    btnExportPdf: $('[data-export-pdf]'),
    btnSaveDesign: $('[data-save-design]'),
    btnShareLink: $('[data-share-link]'),
    btnLoadDesign: $('[data-load-design]'),
    designCodeInput: $('[data-design-code]'),

    powerStatus: $('[data-power-status]'),
    step2Section: root.querySelector('.railcfg__flowSection--draw'),
    step3Section: $('[data-step-power-section]'),
    step4Section: root.querySelector('.railcfg__flowSection--lengths'),
    step5Section: $('[data-spots-section]'),

    // optional rails UI (sidebar)
    railsToggle: $('[data-rails-toggle]'),
    railsClose: $('[data-rails-close]'),
    railsBlock: $('[data-rails-block]'),
    railsMiniStatus: $('[data-rails-mini-status]'),
    colorCard: root.querySelector('.railcfg__card--color'),

    // optional spots carousel
    spotsSection: $('[data-spots-section]'),
    spotsColorLabel: $('[data-spots-color-label]'),
    spotTracks: $$('[data-spots-track]'),
    spotPrev: $('[data-spots-prev]'),
    spotNext: $('[data-spots-next]'),

    // optional accessories carousel
    accessoriesColorLabel: $('[data-accessories-color-label]'),
    accessoryTracks: $$('[data-accessories-track]'),

    addStrips: $('[data-add-strips]'),
    addStripsHint: $('[data-add-strips-hint]'),
    measureModeRadios: $$('[data-measure-mode-radio]'),
    measureModeChoices: $$('[data-measure-choice]'),
    railModeRadios: $$('[data-rail-mode-radio]'),
    railModeChoices: $$('[data-rail-mode-choice]')
  };

  // verplichte elementen
  const mustHaveButtons =
    el.btnUndo.length &&
    el.btnClear.length &&
    el.btnPickPower.length &&
    el.btnClearPower.length &&
    el.btnAddCart.length;

  if (!el.svg || !el.partsBody || !el.summary || !mustHaveButtons) return;

  // Allowed 3-fase colors must be defined before hideUnsupported3PhaseColors() is called
  const ALLOWED_COLORS = ['black', 'white', 'grey'];
  const BUILDTOOL_VARIANT_ID = 55568237658499;

  if (el.workerUrl) el.workerUrl.textContent = WORKER_BASE || '—';
  hideUnsupported3PhaseColors();

  // Store default labels so we can restore them (desktop/mobile may differ)
  el.btnPickPower.forEach((b) => {
    if (!b.dataset.defaultLabel) b.dataset.defaultLabel = (b.textContent || '').trim();
  });
  el.btnAddCart.forEach((b) => {
    if (!b.dataset.defaultLabel) b.dataset.defaultLabel = (b.textContent || '').trim();
  });
  if (el.btnExportPdf && !el.btnExportPdf.dataset.defaultLabel) {
    el.btnExportPdf.dataset.defaultLabel = (el.btnExportPdf.textContent || '').trim();
  }
  if (el.btnSaveDesign && !el.btnSaveDesign.dataset.defaultLabel) {
    el.btnSaveDesign.dataset.defaultLabel = (el.btnSaveDesign.textContent || '').trim();
  }
  if (el.btnShareLink && !el.btnShareLink.dataset.defaultLabel) {
    el.btnShareLink.dataset.defaultLabel = (el.btnShareLink.textContent || '').trim();
  }
  el.btnFinishDraw.forEach((b) => {
    if (!b.dataset.defaultLabel) b.dataset.defaultLabel = (b.textContent || '').trim();
  });

  function setDisabledAll(list, disabled) {
    (list || []).forEach((b) => { b.disabled = !!disabled; });
  }
  function setTextAll(list, text) {
    (list || []).forEach((b) => { b.textContent = text; });
  }
  function restoreDefaultText(list) {
    (list || []).forEach((b) => {
      const t = b.dataset.defaultLabel;
      if (t) b.textContent = t;
    });
  }


  function hideUnsupported3PhaseColors() {
    (el.colorBtns || []).forEach((btn) => {
      const key = String(btn.getAttribute('data-color') || '').trim();
      if (!ALLOWED_COLORS.includes(key)) btn.hidden = true;
    });
    (el.spotTracks || []).forEach((track) => {
      const key = String(track.getAttribute('data-spots-track') || '').trim();
      if (!ALLOWED_COLORS.includes(key)) track.remove();
    });
    (el.accessoryTracks || []).forEach((track) => {
      const key = String(track.getAttribute('data-accessories-track') || '').trim();
      if (!ALLOWED_COLORS.includes(key)) track.remove();
    });
  }

  function bindPress(list, handler) {
    (list || []).forEach((btn) => {
      if (!btn) return;
      btn.addEventListener('click', handler);
      btn.addEventListener('touchend', (evt) => {
        evt.preventDefault();
        handler(evt);
      }, { passive: false });
    });
  }


  function countSelectedAccessories() {
    let total = 0;
    try {
      for (const qty of state.accessoryQtyByVariant.values()) total += clampAccessoryQty(qty);
    } catch (e) {}
    return total;
  }

  async function trackRailcfgEvent(eventName, extra) {
    const event = String(eventName || '').trim();
    if (!event || !WORKER_BASE) return false;

    const payload = Object.assign({
      event,
      designCode: state.designCode || null,
      configurator: '3F',
      color: state.color || null,
      segmentCount: Array.isArray(state.segments) ? state.segments.length : 0,
      enteredLengthCount: countEnteredLengths(),
      spotCount: getTotalSelectedSpotQty(),
      accessoryCount: countSelectedAccessories(),
      meta: {
        pageUrl: window.location.href,
        railMode: state.railMode || 'cut'
      }
    }, extra || {});

    try {
      const res = await fetch(WORKER_BASE + '/track', {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      });

      if (!res.ok) return false;

      const out = await res.json().catch(() => ({}));
      return out?.ok !== false;
    } catch (e) {
      return false;
    }
  }


  function parseCmInput(value) {
    if (value == null) return null;
    const normalized = String(value).trim().replace(',', '.');
    if (!/^\d+(?:\.\d)?$/.test(normalized)) return null;
    const n = Number(normalized);
    if (!isFinite(n) || n <= 0) return null;
    return n;
  }

  function formatCmValue(value) {
    const n = Number(value);
    if (!isFinite(n) || n <= 0) return '';
    if (Math.abs(n - Math.round(n)) < 1e-9) return String(Math.round(n));
    return n.toFixed(1).replace('.', ',');
  }


  function countEnteredLengths() {
    const map = getDisplayLengthMap();
    return map ? map.size : 0;
  }

  function getDisplayLengthMap() {
    if (state.measureMode === 'hart') return state.centerLenCm;
    if (state.measureMode === 'rail') return state.segmentLenCm;
    return null;
  }

  function getNodeCorrectionCm(nodeKeyStr, nodes) {
    const node = nodes.get(nodeKeyStr);
    if (!node) return 0;

    const deg = Array.isArray(node.incident) ? node.incident.length : 0;
    const isPowerNode = !!state.powerKey && nodeKeyStr === state.powerKey;

    if (isPowerNode) {
      if (deg <= 1) return 5.0;
      return 5.0;
    }

    if (deg <= 1) return 0.0;
    if (deg === 2) return isCollinearDegree2Node(nodeKeyStr, nodes) ? 0.0 : 5.0;
    if (deg >= 3) return 5.0;
    return 0.0;
  }

  function getSegmentCorrectionsCm(seg) {
    const nodes = buildNodeMapFromSegments(state.segments);
    const leftKey = pointKey(seg.a);
    const rightKey = pointKey(seg.b);
    return {
      left: getNodeCorrectionCm(leftKey, nodes),
      right: getNodeCorrectionCm(rightKey, nodes)
    };
  }

  function recomputeDerivedLengthsFromMode() {
    pruneSegmentLenMap();
    if (!state.measureMode) return;

    const existing = new Set(state.segments.map(normSegKey));
    for (const k of Array.from(state.centerLenCm.keys())) {
      if (!existing.has(k)) state.centerLenCm.delete(k);
    }

    const nextRail = new Map();
    const nextCenter = new Map();

    state.segments.forEach((seg) => {
      const key = normSegKey(seg);
      const corr = getSegmentCorrectionsCm(seg);

      if (state.measureMode === 'hart') {
        const hart = state.centerLenCm.get(key);
        if (typeof hart === 'number' && isFinite(hart) && hart > 0) {
          nextCenter.set(key, hart);
          const rail = Number((hart - corr.left - corr.right).toFixed(1));
          if (isFinite(rail) && rail > 0) nextRail.set(key, rail);
        }
      } else {
        const rail = state.segmentLenCm.get(key);
        if (typeof rail === 'number' && isFinite(rail) && rail > 0) {
          nextRail.set(key, rail);
          const hart = Number((rail + corr.left + corr.right).toFixed(1));
          if (isFinite(hart) && hart > 0) nextCenter.set(key, hart);
        }
      }
    });

    state.segmentLenCm = nextRail;
    state.centerLenCm = nextCenter;
  }

  function setMeasureMode(nextMode) {
    const mode = nextMode === 'hart' ? 'hart' : (nextMode === 'rail' ? 'rail' : null);
    if (state.measureMode === mode) return;
    state.measureMode = mode;
    recomputeDerivedLengthsFromMode();
    setDesignCode(null);
    render();
  }

  function updateMeasureModeUI() {
    (el.measureModeRadios || []).forEach((radio) => {
      radio.checked = radio.value === state.measureMode;
    });

    (el.measureModeChoices || []).forEach((choice) => {
      const radio = choice.querySelector('[data-measure-mode-radio]');
      const isActive = !!(radio && radio.value === state.measureMode);
      choice.classList.toggle('is-active', isActive);
    });
  }


  function railModeLabel(mode) {
    return mode === 'self' ? 'Zelf op maat maken' : 'Kant-en-klaar geleverd';
  }

  function setRailMode(nextMode) {
    const mode = nextMode === 'self' ? 'self' : 'cut';
    if (state.railMode === mode) return;
    state.railMode = mode;
    setDesignCode(null);
    render();
  }

  function updateRailModeUI() {
    (el.railModeRadios || []).forEach((radio) => {
      radio.checked = radio.value === state.railMode;
    });

    (el.railModeChoices || []).forEach((choice) => {
      const radio = choice.querySelector('[data-rail-mode-radio]');
      const isActive = !!(radio && radio.value === state.railMode);
      choice.classList.toggle('is-active', isActive);
    });
  }

  // ---------------------------
  // Variant IDs (ongewijzigd)
  // ---------------------------
  const VARIANTS = {
    black: {
      XTS11: 55568092594563, XTS12: 55568092725635, XTS14: 55568226222467, XTS41: 55568093086083,
      XTS34: 55568217178499, XTS35: 55568217735555, XTS36: 55568246768003, XTS37: 55568250962307,
      XTS38: 55568301162883, XTS39: 55568251486595, XTS40: 55568252043651,
      XTS4100: 55568221602179, XTS4150: 55567938847107, XTS4200: 55567951528323, XTS4300: 55567951856003,
      XTS4400: 55568222093699, XTS21: 55568093249923
    },
    white: {
      XTS11: 55568091283843, XTS12: 55568088400259, XTS14: 55568223502723, XTS41: 55568092135811,
      XTS34: 55568215736707, XTS35: 55568216621443, XTS36: 55568247849347, XTS37: 55568250274179,
      XTS38: 55568303030659, XTS39: 55568252502403, XTS40: 55568252633475,
      XTS4100: 55568219505027, XTS4150: 55567941239171, XTS4200: 55567951298947, XTS4300: 55567950807427,
      XTS4400: 55568220094851, XTS21: 55568092266883
    },
    grey: {
      XTS11: 55567952413059, XTS12: 55567953002883, XTS14: 55568222912899, XTS41: 55567953461635,
      XTS34: 55568218915203, XTS35: 55568218030467, XTS36: 55568248603011, XTS37: 55568249192835,
      XTS38: 55568303358339, XTS39: 55568252862851, XTS40: 55568253288835,
      XTS4100: 55568220619139, XTS4150: 55567942451587, XTS4200: 55567949627779, XTS4300: 55567950086531,
      XTS4400: 55568221143427, XTS21: 55567953822083
    }
  };

  // ---------------------------
  // Labels
  // ---------------------------
  const NAME = {
    XTS11: 'XTS11 – Eindvoeding',
    XTS12: 'XTS12 – Eindvoeding',
    XTS14: 'XTS14 – Middenvoeding',
    XTS34: 'XTS34 – Hoekstuk',
    XTS35: 'XTS35 – Hoekstuk',
    XTS36: 'XTS36 – T-stuk',
    XTS37: 'XTS37 – T-stuk',
    XTS38: 'XTS38 – Kruisstuk',
    XTS39: 'XTS39 – T-stuk',
    XTS40: 'XTS40 – T-stuk',
    XTS41: 'XTS41 – Eindkap',
    XTS4100: 'XTS4100 – 3-fase rail 1 meter',
    XTS4150: 'XTS4150 – 3-fase rail 1,5 meter',
    XTS4200: 'XTS4200 – 3-fase rail 2 meter',
    XTS4300: 'XTS4300 – 3-fase rail 3 meter',
    XTS4400: 'XTS4400 – 3-fase rail 4 meter',
    XTS21:  'XTS21 – Koppelstuk'
  };

  const colorLabel = (key) => ({
    black: 'Zwart', white: 'Wit', grey: 'Grijs'
  })[key] || key;

  const railLabel = (code) => ({ XTS4100: '1m', XTS4150: '1,5m', XTS4200: '2m', XTS4300: '3m', XTS4400: '4m' })[code] || code;

  const COLOR_INDICATOR_STYLES = {
    black: { bg: '#1b1b1b', text: '#ffffff', border: '#111111' },
    white: { bg: '#f4f4f4', text: '#111111', border: '#d8d6d0' },
    grey: { bg: '#8f9498', text: '#111111', border: '#767b80' }
  };

  function updateColorIndicatorPill() {
    if (!el.colorName) return;

    if (!state.color) {
      el.colorName.textContent = 'Kies uw railkleur';
      el.colorName.style.background = '';
      el.colorName.style.color = '';
      el.colorName.style.borderColor = '';
      return;
    }

    const style = COLOR_INDICATOR_STYLES[state.color];
    el.colorName.textContent = 'Geselecteerd: ' + colorLabel(state.color);

    if (!style) {
      el.colorName.style.background = '';
      el.colorName.style.color = '';
      el.colorName.style.borderColor = '';
      return;
    }

    el.colorName.style.background = style.bg;
    el.colorName.style.color = style.text;
    el.colorName.style.borderColor = style.border;
  }

  function isPremiumColor(colorKey) {
    return false;
  }

  function getStripParts() {
    return new Map();
  }

  function updateStripsUI() {
    state.addStrips = false;
    if (!el.addStrips) return;
    el.addStrips.checked = false;
    el.addStrips.disabled = true;
    const wrap = el.addStrips.closest('.railcfg__summaryOptions');
    if (wrap) wrap.hidden = true;
  }

  function buildPartsGroups() {
    const railOrder = (c) => ({ XTS4400: 1, XTS4300: 2, XTS4200: 3, XTS4150: 4, XTS4100: 5, XTS21: 6 }[c] || 99);
    const groups = [
      {
        title: 'Rails',
        items: Array.from((state.lastRailParts || new Map()).entries())
          .filter(([code, qty]) => qty > 0 && code !== 'XTS21')
          .sort((a, b) => railOrder(a[0]) - railOrder(b[0]))
      },
      {
        title: 'Voedingen',
        items: ['XTS11', 'XTS12', 'XTS14']
          .map((code) => [code, state.lastParts ? (state.lastParts.get(code) || 0) : 0])
          .filter(([, qty]) => qty > 0)
      },
      {
        title: 'Hoek-, T- en kruisstukken',
        items: ['XTS34', 'XTS35', 'XTS36', 'XTS37', 'XTS39', 'XTS40', 'XTS38']
          .map((code) => [code, state.lastParts ? (state.lastParts.get(code) || 0) : 0])
          .filter(([, qty]) => qty > 0)
      },
      {
        title: 'Koppelstukken',
        items: [['XTS21', state.lastRailParts ? (state.lastRailParts.get('XTS21') || 0) : 0]]
          .filter(([, qty]) => qty > 0)
      },
      {
        title: 'Afwerking',
        items: [['XTS41', state.lastParts ? (state.lastParts.get('XTS41') || 0) : 0]]
          .filter(([, qty]) => qty > 0)
      }
    ];

    const stripItems = Array.from(getStripParts().entries()).filter(([, qty]) => qty > 0);
    if (stripItems.length) {
      groups.push({
        title: 'Afdekstrips',
        items: stripItems.sort((a, b) => a[0].localeCompare(b[0]))
      });
    }

    return groups.filter((group) => group.items.length > 0);
  }


  function totalRailMeters() {
    let cm = 0;
    for (const v of state.segmentLenCm.values()) cm += Number(v) || 0;
    return cm > 0 ? (cm / 100) : 0;
  }

  function groupQty(items) {
    return (items || []).reduce((sum, entry) => sum + (Number(entry[1]) || 0), 0);
  }

  function renderPartsPlaceholder(text) {
    el.partsBody.innerHTML = '';
    const empty = document.createElement('div');
    empty.className = 'railcfg__partsEmpty';
    empty.textContent = text || '—';
    el.partsBody.appendChild(empty);
  }

  function renderPartsGroups(groups) {
    el.partsBody.innerHTML = '';

    if (!groups || !groups.length) {
      renderPartsPlaceholder('—');
      return;
    }

    groups.forEach((group) => {
      const section = document.createElement('section');
      section.className = 'railcfg__partsGroup';

      const head = document.createElement('div');
      head.className = 'railcfg__partsGroupHead';

      const title = document.createElement('div');
      title.className = 'railcfg__partsGroupTitle';
      title.textContent = group.title;

      const qty = document.createElement('div');
      qty.className = 'railcfg__partsGroupQty';
      qty.textContent = `${groupQty(group.items)}x`;

      head.appendChild(title);
      head.appendChild(qty);
      section.appendChild(head);

      const list = document.createElement('div');
      list.className = 'railcfg__partsItems';

      group.items.forEach(([code, qtyVal]) => {
        const row = document.createElement('div');
        row.className = 'railcfg__partsItem';

        const name = document.createElement('div');
        name.className = 'railcfg__partsItemName';
        name.textContent = NAME[code] || code;

        const qtyItem = document.createElement('div');
        qtyItem.className = 'railcfg__partsItemQty';
        qtyItem.textContent = `${qtyVal}`;

        row.appendChild(name);
        row.appendChild(qtyItem);
        list.appendChild(row);
      });

      section.appendChild(list);
      el.partsBody.appendChild(section);
    });
  }


  function updateConfidenceUI() {
    const complete = !!(state.lastParts && state.lastRailParts && !state.lenWarning && state.segmentLenCm.size === state.segments.length && state.powerKey && state.color);
    if (el.confidenceBlock) el.confidenceBlock.hidden = !complete;
  }

  function updateCutPlanToggleUI() {
    if (!el.cutPlanToggle || !el.cutPlanWrap) return;
    const hasPlan = !!(state.binPlans && state.binPlans.length && !state.lenWarning && state.segmentLenCm.size > 0);
    el.cutPlanToggle.hidden = !hasPlan;
    el.cutPlanWrap.hidden = !hasPlan || !state.cutPlanOpen;
    el.cutPlanToggle.setAttribute('aria-expanded', hasPlan && state.cutPlanOpen ? 'true' : 'false');
  }

  function updateResultsVisibility() {
    const hasResults = !!(state.lastParts && state.lastRailParts && !state.lenWarning);

    if (el.partsWrap) el.partsWrap.hidden = !hasResults;
    if (el.cutPlanBlock) el.cutPlanBlock.hidden = !hasResults;

    if (!hasResults && el.cutPlanWrap) el.cutPlanWrap.hidden = true;
    if (!hasResults) state.cutPlanOpen = false;
  }

  function updateColorUI() {
    el.colorBtns.forEach((b) => {
      const isActive = !!state.color && b.getAttribute('data-color') === state.color;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    updateColorIndicatorPill();

    if (el.colorCard) el.colorCard.classList.toggle('is-required', !!state.segments.length && !state.color);
  }

  function getActiveSpotTrack() {
    if (!el.spotTracks || !el.spotTracks.length) return null;
    const wanted = state.color || 'black';
    return el.spotTracks.find((track) => track.getAttribute('data-spots-track') === wanted) || el.spotTracks[0] || null;
  }

  function clampSpotQty(value) {
    const n = Number(value) || 0;
    return Math.max(0, Math.min(99, n));
  }

  const POLARIS_DEFAULTS = Object.freeze({
    lightColor: '3000K',
    control: 'Aan/uit (niet dimbaar)',
    beamAngle: '40° – breed (standaard)',
    qty: 0
  });

  function clonePolarisDefaults() {
    return {
      lightColor: POLARIS_DEFAULTS.lightColor,
      control: POLARIS_DEFAULTS.control,
      beamAngle: POLARIS_DEFAULTS.beamAngle,
      qty: POLARIS_DEFAULTS.qty
    };
  }

  function ensurePolarisSelectionsState() {
    if (!state.polarisSelections || typeof state.polarisSelections !== 'object') {
      state.polarisSelections = {};
    }
    ALLOWED_COLORS.forEach((colorKey) => {
      const current = state.polarisSelections[colorKey];
      state.polarisSelections[colorKey] = {
        ...clonePolarisDefaults(),
        ...(current && typeof current === 'object' ? current : {})
      };
      if (String(state.polarisSelections[colorKey].control || '') === 'DALI') {
        state.polarisSelections[colorKey].control = 'Fase dimbaar';
      }
      state.polarisSelections[colorKey].qty = clampSpotQty(state.polarisSelections[colorKey].qty);
    });
  }

  function getPolarisCard(colorKey) {
    return root.querySelector('[data-polaris-card][data-spots-track="' + CSS.escape(colorKey) + '"]');
  }

  function getPolarisVariants(card) {
    if (!card) return [];
    if (Array.isArray(card._polarisVariants)) return card._polarisVariants;
    const script = card.querySelector('[data-polaris-variants]');
    try {
      card._polarisVariants = script ? (JSON.parse(script.textContent || '[]') || []) : [];
    } catch (e) {
      card._polarisVariants = [];
    }
    return card._polarisVariants;
  }

  function getPolarisSelection(colorKey) {
    ensurePolarisSelectionsState();
    return state.polarisSelections[ALLOWED_COLORS.includes(colorKey) ? colorKey : 'black'];
  }

  function getSelectedPolarisVariant(colorKey) {
    const selection = getPolarisSelection(colorKey);
    const variants = getPolarisVariants(getPolarisCard(colorKey));
    let match = variants.find((variant) => String(variant.option1) === String(selection.lightColor) && String(variant.option2) === String(selection.control));
    if (!match) match = variants.find((variant) => variant.available !== false) || variants[0] || null;
    return match || null;
  }

  function syncSelectedVariantIntoSpotQty(colorKey) {
    const variants = getPolarisVariants(getPolarisCard(colorKey));
    if (!state.spotQtyByVariant) state.spotQtyByVariant = new Map();

    Array.from(state.spotQtyByVariant.keys()).forEach((variantId) => {
      if (variants.some((variant) => String(variant.id) === String(variantId))) {
        state.spotQtyByVariant.delete(String(variantId));
      }
    });

    const selection = getPolarisSelection(colorKey);
    const variant = getSelectedPolarisVariant(colorKey);
    if (variant && selection.qty > 0) {
      state.spotQtyByVariant.set(String(variant.id), selection.qty);
    }
  }

  function syncAllPolarisSpotQtyMaps() {
    ensurePolarisSelectionsState();
    ALLOWED_COLORS.forEach((colorKey) => syncSelectedVariantIntoSpotQty(colorKey));
  }

  function buildSpotSelectionsObject() {
    syncAllPolarisSpotQtyMaps();
    const out = {};
    for (const [variantId, qtyRaw] of state.spotQtyByVariant.entries()) {
      const key = String(variantId || '').trim();
      const qty = clampSpotQty(qtyRaw);
      if (!key || qty <= 0) continue;
      out[key] = qty;
    }
    return out;
  }

  function buildSpotConfigObject() {
    ensurePolarisSelectionsState();
    const out = {};
    ALLOWED_COLORS.forEach((colorKey) => {
      const selection = getPolarisSelection(colorKey);
      out[colorKey] = {
        lightColor: String(selection.lightColor || POLARIS_DEFAULTS.lightColor),
        control: String(selection.control || POLARIS_DEFAULTS.control),
        beamAngle: String(selection.beamAngle || POLARIS_DEFAULTS.beamAngle),
        qty: clampSpotQty(selection.qty)
      };
    });
    return out;
  }

  function buildSpotItemsForPdf() {
    const items = [];
    ensurePolarisSelectionsState();

    ALLOWED_COLORS.forEach((colorKey) => {
      const selection = getPolarisSelection(colorKey);
      const qty = clampSpotQty(selection.qty);
      if (qty <= 0) return;

      const card = getPolarisCard(colorKey);
      const variant = getSelectedPolarisVariant(colorKey);
      if (!card || !variant) return;

      const title = [
        String(card.getAttribute('data-product-title') || '3F railspot POLARIS II').trim(),
        String(selection.lightColor || '').trim(),
        String(selection.control || '').trim(),
        String(selection.beamAngle || '').trim()
      ].filter(Boolean).join(' – ');

      const imgEl = card.querySelector('.railcfg__spotImg');
      const rawImageUrl = String((imgEl && (imgEl.currentSrc || imgEl.getAttribute('src') || imgEl.dataset.src)) || '').trim();

      let imageUrl = '';
      if (rawImageUrl) {
        try { imageUrl = new URL(rawImageUrl, window.location.origin).href; }
        catch (e) { imageUrl = rawImageUrl; }
      }

      items.push({ variantId: String(variant.id), qty, title, imageUrl });
    });

    return items;
  }

  function restoreSpotSelections(input) {
    state.spotQtyByVariant = new Map();
    ensurePolarisSelectionsState();
    if (!input || typeof input !== 'object') return;

    ALLOWED_COLORS.forEach((colorKey) => {
      const variants = getPolarisVariants(getPolarisCard(colorKey));
      if (!variants.length) return;

      Object.entries(input).forEach(([variantId, qtyRaw]) => {
        const qty = clampSpotQty(qtyRaw);
        if (qty <= 0) return;
        const match = variants.find((variant) => String(variant.id) === String(variantId || '').trim());
        if (!match) return;

        state.polarisSelections[colorKey] = {
          ...getPolarisSelection(colorKey),
          lightColor: String(match.option1 || POLARIS_DEFAULTS.lightColor),
          control: String(match.option2 || POLARIS_DEFAULTS.control),
          qty
        };
        state.spotQtyByVariant.set(String(match.id), qty);
      });
    });
  }

  function restoreSpotConfig(input) {
    ensurePolarisSelectionsState();
    if (!input || typeof input !== 'object') return;
    ALLOWED_COLORS.forEach((colorKey) => {
      const value = input[colorKey];
      if (!value || typeof value !== 'object') return;
      state.polarisSelections[colorKey] = {
        ...getPolarisSelection(colorKey),
        lightColor: String(value.lightColor || POLARIS_DEFAULTS.lightColor),
        control: String(value.control || POLARIS_DEFAULTS.control),
        beamAngle: String(value.beamAngle || POLARIS_DEFAULTS.beamAngle),
        qty: clampSpotQty(value.qty)
      };
    });
    syncAllPolarisSpotQtyMaps();
  }

  function updateSpotQtyUI(card) {
    if (!card) return;
    const colorKey = String(card.getAttribute('data-spots-track') || '').trim();
    const selection = getPolarisSelection(colorKey);
    const variant = getSelectedPolarisVariant(colorKey);
    const qty = clampSpotQty(selection.qty);

    const qtyEl = card.querySelector('[data-spot-qty]');
    const minus = card.querySelector('[data-spot-minus]');
    const priceEl = card.querySelector('[data-polaris-price]');
    if (qtyEl) qtyEl.textContent = String(qty);
    if (minus) minus.disabled = qty <= 0;
    if (priceEl && variant) {
      const incl = String(variant.priceInclText || variant.priceText || '').trim();
      const excl = String(variant.priceExclText || '').trim();

      priceEl.innerHTML = '';
      priceEl.classList.add('railcfg__spotPrice--dual');

      const inclEl = document.createElement('span');
      inclEl.className = 'railcfg__priceIncl';
      inclEl.textContent = incl;
      priceEl.appendChild(inclEl);

      if (excl) {
        const exclEl = document.createElement('span');
        exclEl.className = 'railcfg__priceExcl';
        exclEl.textContent = `(${excl})`;
        priceEl.appendChild(exclEl);
      }
    }

    card.classList.toggle('is-selected', qty > 0);

    card.querySelectorAll('[data-polaris-light]').forEach((btn) => {
      const active = String(btn.getAttribute('data-polaris-light') || '') === String(selection.lightColor || '');
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    card.querySelectorAll('[data-polaris-control]').forEach((btn) => {
      const active = String(btn.getAttribute('data-polaris-control') || '') === String(selection.control || '');
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    card.querySelectorAll('[data-polaris-beam]').forEach((btn) => {
      const active = String(btn.getAttribute('data-polaris-beam') || '') === String(selection.beamAngle || '');
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateSpotsUI() {
    if (!el.spotsSection || !el.spotTracks || !el.spotTracks.length) return;

    const activeColor = state.color || 'black';
    ensurePolarisSelectionsState();
    syncAllPolarisSpotQtyMaps();

    el.spotTracks.forEach((track) => {
      const isActive = track.getAttribute('data-spots-track') === activeColor;
      track.classList.toggle('is-active', isActive);
      track.hidden = !isActive;
      track.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      track.style.display = isActive ? 'block' : 'none';
      updateSpotQtyUI(track);
    });

    if (el.spotsColorLabel) {
      el.spotsColorLabel.textContent = state.color ? colorLabel(state.color) : 'Zwart';
    }
    if (el.spotPrev) el.spotPrev.disabled = true;
    if (el.spotNext) el.spotNext.disabled = true;
  }

  function setSpotQty(colorKey, nextQty) {
    const selection = getPolarisSelection(colorKey);
    selection.qty = clampSpotQty(nextQty);
    syncSelectedVariantIntoSpotQty(colorKey);
    setDesignCode(null);
    updateSpotsUI();
    updateOfferButtonVisibility();
    saveAutosave();
  }

  function getTotalSelectedSpotQty() {
    ensurePolarisSelectionsState();
    return ALLOWED_COLORS.reduce((sum, colorKey) => sum + clampSpotQty(getPolarisSelection(colorKey).qty), 0);
  }

  function updateOfferButtonVisibility() {
    if (!el.btnOffer) return;
    el.btnOffer.hidden = false;
  }

  function setOfferPanelOpen(open) {
    if (!el.offerPanel || !el.btnOffer) return;
    const isOpen = !!open;
    el.offerPanel.hidden = !isOpen;
    el.offerPanel.classList.toggle('is-open', isOpen);
    el.btnOffer.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function setOfferFormMsg(text, kind) {
    if (!el.offerFormMsg) return;
    const msg = String(text || '').trim();
    el.offerFormMsg.textContent = msg;
    el.offerFormMsg.hidden = !msg;
    el.offerFormMsg.classList.remove('is-ok', 'is-err');
    if (!msg) return;
    el.offerFormMsg.classList.add(kind === 'err' ? 'is-err' : 'is-ok');
  }

  async function ensureOfferDesignCode() {
    if (!state.segments.length) throw new Error('Teken eerst een ontwerp voordat u een aanvraag verstuurt.');
    if (!state.designCode) {
      setOfferFormMsg('Ontwerpcode wordt aangemaakt…', 'ok');
      const saved = await saveDesignOnServer();
      setDesignCode(saved.code);
    }
    if (el.offerDesignCode) el.offerDesignCode.value = state.designCode || '';
    setOfferFormMsg('', 'ok');
    return state.designCode || '';
  }

  function getSpotCartItems() {
    const items = [];
    const colorKey = state.color || 'black';
    const selection = getPolarisSelection(colorKey);
    const qty = clampSpotQty(selection.qty);
    const variant = getSelectedPolarisVariant(colorKey);

    if (variant && qty > 0) {
      items.push({
        id: Number(variant.id),
        quantity: qty,
        properties: {
          Reflectorhoek: String(selection.beamAngle || POLARIS_DEFAULTS.beamAngle)
        }
      });
    }

    return items;
  }

  function getActiveAccessoryVariantIds() {
    const activeColor = state.color || 'black';
    const ids = new Set();

    (el.accessoryTracks || []).forEach((track) => {
      if (String(track.getAttribute('data-accessories-track') || '').trim() !== activeColor) return;

      track.querySelectorAll('[data-accessory-card][data-accessory-variant-id]').forEach((card) => {
        const variantId = String(card.getAttribute('data-accessory-variant-id') || '').trim();
        if (variantId) ids.add(variantId);
      });
    });

    return ids;
  }

  function pruneAccessorySelectionsToActiveColor() {
    const allowedIds = getActiveAccessoryVariantIds();

    for (const variantId of Array.from(state.accessoryQtyByVariant.keys())) {
      if (!allowedIds.has(String(variantId))) state.accessoryQtyByVariant.delete(String(variantId));
    }
  }

  function getAccessoryCartItems() {
    const items = [];
    const allowedIds = getActiveAccessoryVariantIds();

    if (!allowedIds.size) return items;

    for (const [variantId, qtyRaw] of state.accessoryQtyByVariant.entries()) {
      const key = String(variantId || '').trim();
      const id = Number(key);
      const qty = clampAccessoryQty(qtyRaw);
      if (!id || qty <= 0) continue;
      if (!allowedIds.has(key)) continue;
      items.push({ id, quantity: qty });
    }

    return items;
  }

  function bindSpotCarousel() {
    if (!el.spotTracks || !el.spotTracks.length) return;

    ensurePolarisSelectionsState();

    el.spotTracks.forEach((track) => {
      const colorKey = String(track.getAttribute('data-spots-track') || '').trim();
      track.querySelectorAll('[data-polaris-light]').forEach((btn) => {
        btn.addEventListener('click', () => {
          getPolarisSelection(colorKey).lightColor = String(btn.getAttribute('data-polaris-light') || POLARIS_DEFAULTS.lightColor);
          syncSelectedVariantIntoSpotQty(colorKey);
          setDesignCode(null);
          updateSpotsUI();
          saveAutosave();
        });
      });
      track.querySelectorAll('[data-polaris-control]').forEach((btn) => {
        btn.addEventListener('click', () => {
          getPolarisSelection(colorKey).control = String(btn.getAttribute('data-polaris-control') || POLARIS_DEFAULTS.control);
          syncSelectedVariantIntoSpotQty(colorKey);
          setDesignCode(null);
          updateSpotsUI();
          saveAutosave();
        });
      });
      track.querySelectorAll('[data-polaris-beam]').forEach((btn) => {
        btn.addEventListener('click', () => {
          getPolarisSelection(colorKey).beamAngle = String(btn.getAttribute('data-polaris-beam') || POLARIS_DEFAULTS.beamAngle);
          setDesignCode(null);
          updateSpotsUI();
          saveAutosave();
        });
      });

      const plus = track.querySelector('[data-spot-plus]');
      const minus = track.querySelector('[data-spot-minus]');
      if (plus) plus.addEventListener('click', () => setSpotQty(colorKey, getPolarisSelection(colorKey).qty + 1));
      if (minus) minus.addEventListener('click', () => setSpotQty(colorKey, getPolarisSelection(colorKey).qty - 1));

      updateSpotQtyUI(track);
    });

    if (el.spotPrev) el.spotPrev.addEventListener('click', () => {});
    if (el.spotNext) el.spotNext.addEventListener('click', () => {});
    updateSpotsUI();
  }


  function clampAccessoryQty(value) {
    const n = Number(value) || 0;
    return Math.max(0, Math.min(99, n));
  }

  function buildAccessorySelectionsObject() {
    const out = {};
    for (const [variantId, qtyRaw] of state.accessoryQtyByVariant.entries()) {
      const key = String(variantId || '').trim();
      const qty = clampAccessoryQty(qtyRaw);
      if (!key || qty <= 0) continue;
      out[key] = qty;
    }
    return out;
  }

  function saveAccessorySelections() {
    try {
      const data = buildAccessorySelectionsObject();
      if (!Object.keys(data).length) {
        localStorage.removeItem(ACCESSORY_QTY_KEY);
        return;
      }
      localStorage.setItem(ACCESSORY_QTY_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function restoreAccessorySelections(input) {
    state.accessoryQtyByVariant = new Map();

    if (!input || typeof input !== 'object') return;

    for (const [variantId, qtyRaw] of Object.entries(input)) {
      const key = String(variantId || '').trim();
      const qty = clampAccessoryQty(qtyRaw);
      if (!key || qty <= 0) continue;
      state.accessoryQtyByVariant.set(key, qty);
    }
  }

  function loadAccessorySelections() {
    try {
      const raw = localStorage.getItem(ACCESSORY_QTY_KEY);
      if (!raw) return false;
      const obj = JSON.parse(raw);
      restoreAccessorySelections(obj);
      return true;
    } catch (e) {
      return false;
    }
  }

  function updateAccessoryQtyUI(card) {
    if (!card) return;
    const variantId = String(card.getAttribute('data-accessory-variant-id') || '').trim();
    const qty = clampAccessoryQty(state.accessoryQtyByVariant.get(variantId) || 0);
    const qtyEl = card.querySelector('[data-accessory-qty]');
    const minus = card.querySelector('[data-accessory-minus]');
    const addBtn = card.querySelector('[data-accessory-add]');
    if (qtyEl) qtyEl.textContent = String(qty);
    if (minus) minus.disabled = qty <= 0;
    if (addBtn) addBtn.disabled = qty <= 0;
    card.classList.toggle('is-selected', qty > 0);
  }

  function setAccessoryQty(variantId, nextQty) {
    const key = String(variantId || '').trim();
    if (!key) return;
    const qty = clampAccessoryQty(nextQty);
    if (qty <= 0) state.accessoryQtyByVariant.delete(key);
    else state.accessoryQtyByVariant.set(key, qty);

    setDesignCode(null);
    saveAccessorySelections();
    saveAutosave();

    const selector = '[data-accessory-card][data-accessory-variant-id="' + CSS.escape(key) + '"]';
    const card = root.querySelector(selector);
    if (card) updateAccessoryQtyUI(card);
  }

  function updateAccessoriesUI() {
    if (!el.accessoryTracks || !el.accessoryTracks.length) return;

    const activeColor = state.color || 'black';
    let activeTrack = null;

    el.accessoryTracks.forEach((track) => {
      const isActive = track.getAttribute('data-accessories-track') === activeColor;
      track.classList.toggle('is-active', isActive);
      track.hidden = !isActive;
      track.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      track.style.display = isActive ? 'grid' : 'none';
      if (isActive) activeTrack = track;

      track.querySelectorAll('[data-accessory-card]').forEach((card) => updateAccessoryQtyUI(card));
    });

    if (!activeTrack && el.accessoryTracks[0]) {
      activeTrack = el.accessoryTracks[0];
      activeTrack.classList.add('is-active');
      activeTrack.hidden = false;
      activeTrack.setAttribute('aria-hidden', 'false');
      activeTrack.style.display = 'grid';
    }

    if (el.accessoriesColorLabel) {
      el.accessoriesColorLabel.textContent = state.color ? colorLabel(state.color) : 'Zwart';
    }
  }

  async function handleAccessoryAdd(card) {
    if (!card) return;

    const variantId = Number(card.getAttribute('data-accessory-variant-id') || 0);
    const key = String(variantId || '').trim();
    const qty = clampAccessoryQty(state.accessoryQtyByVariant.get(key) || 0);
    const addBtn = card.querySelector('[data-accessory-add]');
    const defaultLabel = addBtn ? (addBtn.dataset.defaultLabel || addBtn.textContent || 'Toevoegen') : 'Toevoegen';

    if (!variantId || qty <= 0 || !addBtn) return;

    addBtn.disabled = true;
    addBtn.textContent = 'Toevoegen…';

    try {
      await addToCart([{ id: variantId, quantity: qty }]);
      state.accessoryQtyByVariant.delete(key);
      saveAccessorySelections();
      updateAccessoryQtyUI(card);
      addBtn.textContent = 'Toegevoegd ✓';
      card.classList.add('is-added');

      window.setTimeout(() => {
        card.classList.remove('is-added');
        addBtn.textContent = defaultLabel;
        updateAccessoryQtyUI(card);
      }, 1600);
    } catch (err) {
      addBtn.textContent = 'Probeer opnieuw';
      window.setTimeout(() => {
        addBtn.textContent = defaultLabel;
        updateAccessoryQtyUI(card);
      }, 1800);
      console.error(err);
    }
  }

  function bindAccessoryCarousel() {
    if (!el.accessoryTracks || !el.accessoryTracks.length) return;

    el.accessoryTracks.forEach((track) => {
      track.querySelectorAll('[data-accessory-card]').forEach((card) => {
        const variantId = String(card.getAttribute('data-accessory-variant-id') || '').trim();
        const plus = card.querySelector('[data-accessory-plus]');
        const minus = card.querySelector('[data-accessory-minus]');
        const addBtn = card.querySelector('[data-accessory-add]');

        if (addBtn && !addBtn.dataset.defaultLabel) {
          addBtn.dataset.defaultLabel = (addBtn.textContent || '').trim() || 'Toevoegen';
        }

        if (plus) {
          plus.addEventListener('click', () => {
            const cur = clampAccessoryQty(state.accessoryQtyByVariant.get(variantId) || 0);
            setAccessoryQty(variantId, cur + 1);
          });
        }

        if (minus) {
          minus.addEventListener('click', () => {
            const cur = clampAccessoryQty(state.accessoryQtyByVariant.get(variantId) || 0);
            setAccessoryQty(variantId, cur - 1);
          });
        }

        if (addBtn) {
          addBtn.addEventListener('click', () => {
            handleAccessoryAdd(card);
          });
        }

        updateAccessoryQtyUI(card);
      });
    });

    updateAccessoriesUI();
  }

  function setMsg(text, kind) {
    if (!el.cartMsg) return;
    el.cartMsg.textContent = text || '';
    el.cartMsg.classList.remove('is-ok', 'is-err');
    if (kind) el.cartMsg.classList.add(kind === 'ok' ? 'is-ok' : 'is-err');
  }

  function isCriticalConfigAlertMessage(text) {
    const msg = String(text || '').trim();
    if (!msg) return false;

    if (msg === getInvalidStraightSplitMessage()) return true;

    return (
      msg.startsWith('Er is iets misgegaan bij het berekenen van uw configuratie') ||
      msg.startsWith('De configurator is nog niet volledig ingesteld') ||
      msg.startsWith('Geen passende onderdelen gevonden') ||
      msg.startsWith('Worker URL ontbreekt') ||
      msg.startsWith('Export mislukt')
    );
  }

  function setConfigAlert(text) {
    if (!el.configAlert) return;
    const msg = String(text || '').trim();
    if (!msg || !isCriticalConfigAlertMessage(msg)) {
      el.configAlert.hidden = true;
      el.configAlert.textContent = '';
      return;
    }
    el.configAlert.textContent = msg;
    el.configAlert.hidden = false;
  }

  function clearConfigAlert() {
    if (!el.configAlert) return;
    el.configAlert.hidden = true;
    el.configAlert.textContent = '';
  }


  function syncRailValidationAlert() {
    const railMsg = getRailValidationMessage();
    if (railMsg) {
      setConfigAlert(railMsg);
      return;
    }

    if (!el.configAlert) return;
    const current = String(el.configAlert.textContent || '').trim();
    if (current === getInvalidStraightSplitMessage()) {
      clearConfigAlert();
    }
  }

  let designMsgTimer = null;

  function setDesignMsg(text, kind) {
    if (!el.designMsg) return;

    if (designMsgTimer) {
      clearTimeout(designMsgTimer);
      designMsgTimer = null;
    }

    el.designMsg.textContent = text || '';
    el.designMsg.classList.remove('is-ok', 'is-err', 'is-visible');

    if (!text) return;

    if (kind) el.designMsg.classList.add(kind === 'ok' ? 'is-ok' : 'is-err');

    void el.designMsg.offsetWidth;
    el.designMsg.classList.add('is-visible');

    designMsgTimer = window.setTimeout(() => {
      if (!el.designMsg) return;
      el.designMsg.classList.remove('is-visible');
    }, 3000);
  }


  function setDesignCode(code) {
    state.designCode = code ? normalizeDesignCode(code) : null;
    if (el.designCodeInput) el.designCodeInput.value = state.designCode || '';
  }

  function normalizeDesignCode(code) {
    return String(code || '').trim().toUpperCase().replace(/[^A-Z0-9-]/g, '');
  }

  function focusDesignCode(selectAll) {
    if (!el.designCodeInput) return;
    try {
      el.designCodeInput.focus({ preventScroll: true });
    } catch (e) {
      el.designCodeInput.focus();
    }
    if (selectAll) {
      try { el.designCodeInput.select(); } catch (e) {}
    }
  }

  function getShortDesignUrl(code) {
    if (!WORKER_BASE || !code) return '';
    return WORKER_BASE + '/r/' + encodeURIComponent(code);
  }

  async function saveDesignOnServer() {
  if (!WORKER_BASE) throw new Error('Worker URL ontbreekt (section setting).');
  if (!state.segments.length) throw new Error('Teken eerst een ontwerp.');

  const segLenObj = {};
  for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

  const centerLenObj = {};
  for (const [k, v] of state.centerLenCm.entries()) centerLenObj[k] = v;

  const payload = {
    color: state.color,
    powerKey: state.powerKey,
    segments: state.segments,
    measureMode: state.measureMode,
    railMode: state.railMode,
    segmentLenCm: segLenObj,
    centerLenCm: centerLenObj,
    addStrips: false,
    spotSelections: buildSpotSelectionsObject(),
    accessorySelections: buildAccessorySelectionsObject()
  };

  const res = await fetch(WORKER_BASE + '/save', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  const out = await res.json().catch(() => ({}));
  if (!res.ok || out?.ok === false || !out?.code) {
    throw new Error(out?.reason || `Opslaan mislukt (${res.status})`);
  }

  setDesignCode(out.code);
  saveAutosave();
  return out;
}

async function loadDesignByCode(code) {
  if (!WORKER_BASE) throw new Error('Worker URL ontbreekt (section setting).');

  const res = await fetch(WORKER_BASE + '/load/' + encodeURIComponent(code), {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
  });

  const out = await res.json().catch(() => ({}));
  if (!res.ok || out?.ok === false || !out?.config) {
    throw new Error(out?.reason || 'Ontwerp niet gevonden.');
  }

  const ok = applyCfgObject(out.config);
  if (!ok) throw new Error('Opgeslagen ontwerp is ongeldig.');

  setDesignCode(out.code || code);
  saveAutosave();
  return true;
}


  async function handleSaveDesignOnly() {
    if (!state.segments.length) {
      setDesignMsg('Teken eerst een ontwerp om te kunnen bewaren.', 'err');
      return;
    }

    try {
      if (el.btnSaveDesign) {
        el.btnSaveDesign.disabled = true;
        el.btnSaveDesign.textContent = 'Bewaren…';
      }

      if (state.designCode) {
        saveAutosave();
        focusDesignCode(true);
        trackRailcfgEvent('save_design_click');
        setDesignMsg(`Ontwerp ${state.designCode} is al opgeslagen.`, 'ok');
        return;
      }

      setDesignMsg('Ontwerp wordt opgeslagen…', 'ok');
      const out = await saveDesignOnServer();
      focusDesignCode(true);
      trackRailcfgEvent('save_design_click', { designCode: out.code || state.designCode });
      setDesignMsg(`Ontwerp ${out.code} is opgeslagen.`, 'ok');
    } catch (err) {
      setDesignMsg(err?.message || 'Ontwerp opslaan mislukt.', 'err');
    } finally {
      if (el.btnSaveDesign) {
        el.btnSaveDesign.disabled = false;
        el.btnSaveDesign.textContent = el.btnSaveDesign.dataset.defaultLabel || 'Bewaar ontwerp';
      }
    }
  }


  async function handleManualLoadDesign() {
    try {
      const code = normalizeDesignCode(el.designCodeInput ? el.designCodeInput.value : '');
      if (!code) {
        setDesignMsg('Vul eerst een ontwerpcode in.', 'err');
        if (el.designCodeInput) el.designCodeInput.focus();
        return;
      }

  if (el.btnLoadDesign) {
        el.btnLoadDesign.disabled = true;
        el.btnLoadDesign.textContent = 'Laden…';
      }

      setDesignMsg('Ontwerp wordt geladen…', 'ok');
      await loadDesignByCode(code);
      render();
      focusDesignCode(false);
      setDesignMsg(`Ontwerp ${code} geladen.`, 'ok');
    } catch (err) {
      setDesignMsg(err?.message || 'Ontwerp laden mislukt.', 'err');
    } finally {

  if (el.btnLoadDesign) {
        el.btnLoadDesign.disabled = false;
        el.btnLoadDesign.textContent = 'Openen';
      }
    }
  }

  async function setCartAttributes(attrs) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs || {} })
    });
    if (!res.ok) {
      let txt = '';
      try { txt = await res.text(); } catch (e) {}
      throw new Error('Cart update failed: ' + (txt || res.status));
    }
    return await res.json();
  }

  // ---------------------------
  // Drawing + geometry helpers
  // ---------------------------
  const SNAP_CM = 10;
  const UNIT_PER_10CM = 50;
  const unitPerCm = () => UNIT_PER_10CM / 10;

  function snap(v) {
    const step = SNAP_CM * unitPerCm();
    return Math.round(v / step) * step;
  }
  const samePoint = (p, q) => p.x === q.x && p.y === q.y;
  const pointKey = (p) => `${p.x},${p.y}`;

  function normSegKey(seg) {
    const a = { x: seg.a.x, y: seg.a.y };
    const b = { x: seg.b.x, y: seg.b.y };
    if (a.x === b.x) {
      if (a.y > b.y) { const t = a.y; a.y = b.y; b.y = t; }
    } else {
      if (a.x > b.x) { const t = a.x; a.x = b.x; b.x = t; }
    }
    return `${a.x},${a.y}|${b.x},${b.y}`;
  }

  function segmentMidpoint(seg) {
    return { x: (seg.a.x + seg.b.x) / 2, y: (seg.a.y + seg.b.y) / 2 };
  }
  function segmentLabelOffset(seg) {
    const dx = seg.b.x - seg.a.x;
    const dy = seg.b.y - seg.a.y;
    return (Math.abs(dx) >= Math.abs(dy)) ? { ox: 0, oy: -18 } : { ox: 18, oy: 0 };
  }

  function normSeg(seg) {
    const a = { x: seg.a.x, y: seg.a.y };
    const b = { x: seg.b.x, y: seg.b.y };
    if (a.y === b.y) {
      if (a.x > b.x) { const t = a.x; a.x = b.x; b.x = t; }
      return { a, b, ori: 'H' };
    }
    if (a.y > b.y) { const t = a.y; a.y = b.y; b.y = t; }
    return { a, b, ori: 'V' };
  }
  function onSegment(p, seg) {
    const s = normSeg(seg);
    if (s.ori === 'H') return p.y === s.a.y && p.x >= s.a.x && p.x <= s.b.x;
    return p.x === s.a.x && p.y >= s.a.y && p.y <= s.b.y;
  }
  function distPointToSeg(p, seg) {
    const a = seg.a, b = seg.b;
    if (a.x === b.x) {
      const x = a.x;
      const y1 = Math.min(a.y, b.y), y2 = Math.max(a.y, b.y);
      const yy = Math.max(y1, Math.min(p.y, y2));
      return Math.hypot(p.x - x, p.y - yy);
    } else {
      const y = a.y;
      const x1 = Math.min(a.x, b.x), x2 = Math.max(a.x, b.x);
      const xx = Math.max(x1, Math.min(p.x, x2));
      return Math.hypot(p.y - y, p.x - xx);
    }
  }
  function closestPointOnSegSnapped(p, seg) {
    const a = seg.a, b = seg.b;
    let q;
    if (a.x === b.x) {
      const x = a.x;
      const y1 = Math.min(a.y, b.y), y2 = Math.max(a.y, b.y);
      const y = Math.max(y1, Math.min(p.y, y2));
      q = { x, y };
    } else {
      const y = a.y;
      const x1 = Math.min(a.x, b.x), x2 = Math.max(a.x, b.x);
      const x = Math.max(x1, Math.min(p.x, x2));
      q = { x, y };
    }
    return { x: snap(q.x), y: snap(q.y) };
  }

  function svgPointFromEvent(evt) {
    const pt = el.svg.createSVGPoint();
    const e = evt.touches ? evt.touches[0] : evt;
    pt.x = e.clientX; pt.y = e.clientY;
    const ctm = el.svg.getScreenCTM();
    if (!ctm) return { x: 0, y: 0 };
    const p = pt.matrixTransform(ctm.inverse());
    return { x: p.x, y: p.y };
  }

  function normalizeSegment(a, b) {
    const dx = Math.abs(b.x - a.x);
    const dy = Math.abs(b.y - a.y);
    return (dx >= dy) ? { a, b: { x: b.x, y: a.y } } : { a, b: { x: a.x, y: b.y } };
  }

  function isEditable() {
    return !state.isLocked;
  }

  function updateLockUI() {
    const locked = !!state.isLocked;

    if (el.svg) {
      el.svg.style.cursor = locked ? 'not-allowed' : 'crosshair';
    }

    setDisabledAll(el.btnUndo, locked);
    setDisabledAll(el.btnClear, locked);
    setDisabledAll(el.btnPickPower, !state.segments.length);
    setDisabledAll(el.btnClearPower, !state.powerKey);
  }

  function scrollToSection(target) {
    if (!target) return;

    const rect = target.getBoundingClientRect();
    const absoluteTop = rect.top + window.scrollY;
    const top = Math.max(0, absoluteTop - 24);

    window.scrollTo({ top, behavior: 'smooth' });
  }

  function scrollToDrawStep() {
    scrollToSection(el.step2Section);
  }

  function scrollToPowerStep() {
    scrollToSection(el.step3Section);
  }

  function scrollToLengthsStep() {
    scrollToSection(el.step4Section);
  }

  function scrollToSpotsStep() {
    scrollToSection(el.step5Section);
  }

  function finishDrawingAndAdvance() {
    if (!state.segments.length) return;
    if (hasRailValidationError()) {
      setConfigAlert(getRailValidationMessage());
      updateCanvasStatus();
      return;
    }

    drawing.active = false;
    drawing.start = null;
    stopPreview();
    state.pickPowerMode = false;

    const lengthsComplete = state.segmentLenCm.size === state.segments.length;

    render();

    window.setTimeout(() => {
      if (!state.powerKey) {
        scrollToPowerStep();
        return;
      }

      if (!lengthsComplete) {
        scrollToLengthsStep();
        return;
      }

      scrollToSpotsStep();
    }, 60);
  }

  // ---------------------------
  // State
  // ---------------------------
  const state = {
    points: [],
    segments: [],
    powerKey: null,
    pickPowerMode: false,
    color: null,
    designCode: null,
    measureMode: null,
    railMode: 'cut',
    segmentLenCm: new Map(), // Map<segKey, rail-cm>
    centerLenCm: new Map(),  // Map<segKey, hart-cm>
    isLocked: false,
    spotQtyByVariant: new Map(),
    polarisSelections: {},
    accessoryQtyByVariant: new Map(),
    addStrips: false,
    cutPlanOpen: false,

    // Worker cache
    lastWorkerOut: null,
    lastParts: null,       // Map
    lastRailParts: null,   // Map incl GB21
    binPlans: null,        // Array

    lenWarning: false,
    lenWarningText: '',
    invalidStraightSplit: false,
    invalidStraightSplitMessage: ''
  };

  const AUTOSAVE_KEY = 'railcfg_autosave_v1';
  const ACCESSORY_QTY_KEY = 'railcfg_3f_accessory_qty_v1';

  function buildAutosaveObject() {
    const segLenObj = {};
    for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

    const centerLenObj = {};
    for (const [k, v] of state.centerLenCm.entries()) centerLenObj[k] = v;

    return {
      color: state.color,
      powerKey: state.powerKey,
      segments: state.segments,
      measureMode: state.measureMode,
      railMode: state.railMode,
      segmentLenCm: segLenObj,
      centerLenCm: centerLenObj,
      designCode: state.designCode || null,
      addStrips: false,
      spotSelections: buildSpotSelectionsObject(),
      spotConfig: buildSpotConfigObject(),
      accessorySelections: buildAccessorySelectionsObject()
    };
  }

  function saveAutosave() {
    try {
      if (!state.segments.length) {
        localStorage.removeItem(AUTOSAVE_KEY);
        return;
      }
      localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(buildAutosaveObject()));
    } catch (e) {}
  }

  function loadAutosave() {
    try {
      const raw = localStorage.getItem(AUTOSAVE_KEY);
      if (!raw) return false;
      const obj = JSON.parse(raw);
      const ok = applyCfgObject(obj);
      if (ok && obj.designCode) setDesignCode(obj.designCode);
      return !!ok;
    } catch (e) {
      return false;
    }
  }

  function clearAutosave() {
    try {
      localStorage.removeItem(AUTOSAVE_KEY);
    } catch (e) {}
  }

  // ---------------------------
  // Shareable link (?cfg=...)
  // ---------------------------
  let shareTimer = null;
  let lastCfgStr = null;

  function toBase64Url(u8) {
    let bin = '';
    for (let i = 0; i < u8.length; i++) bin += String.fromCharCode(u8[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }
  function fromBase64Url(s) {
    const b64 = s.replace(/-/g, '+').replace(/_/g, '/');
    const pad = '='.repeat((4 - (b64.length % 4)) % 4);
    const bin = atob(b64 + pad);
    const u8 = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
    return u8;
  }

  function buildCfgObject() {
    const segLenObj = {};
    for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

    const centerLenObj = {};
    for (const [k, v] of state.centerLenCm.entries()) centerLenObj[k] = v;

    return {
      v: 1,
      color: state.color,
      powerKey: state.powerKey,
      segments: state.segments,
      measureMode: state.measureMode,
      railMode: state.railMode,
      segmentLenCm: segLenObj,
      centerLenCm: centerLenObj,
      addStrips: false,
      spotSelections: buildSpotSelectionsObject(),
      spotConfig: buildSpotConfigObject(),
      accessorySelections: buildAccessorySelectionsObject()
    };
  }

  function encodeCfg(obj) {
    const json = JSON.stringify(obj);
    const u8 = new TextEncoder().encode(json);
    return toBase64Url(u8);
  }

  function decodeCfg(cfgStr) {
    const u8 = fromBase64Url(cfgStr);
    const json = new TextDecoder().decode(u8);
    return JSON.parse(json);
  }

  function setUrlCfg(cfgStr) {
    const url = new URL(window.location.href);
    if (!cfgStr) url.searchParams.delete('cfg');
    else url.searchParams.set('cfg', cfgStr);
    history.replaceState(null, '', url.toString());
  }

function scheduleShareUpdate() {
  // cfg-links niet meer genereren
}

  function applyCfgObject(obj) {
    if (!obj || !Array.isArray(obj.segments)) return false;

    const color = obj.color == null ? null : String(obj.color || '').trim();
    state.color = (color && (color in VARIANTS)) ? color : null;

    state.segments = obj.segments.map(s => ({
      a: { x: Number(s.a.x), y: Number(s.a.y) },
      b: { x: Number(s.b.x), y: Number(s.b.y) }
    })).filter(s => isFinite(s.a.x) && isFinite(s.a.y) && isFinite(s.b.x) && isFinite(s.b.y));

    state.powerKey = obj.powerKey ? String(obj.powerKey) : null;
    state.measureMode = obj.measureMode === 'hart' ? 'hart' : (obj.measureMode === 'rail' ? 'rail' : null);
    state.railMode = obj.railMode === 'self' ? 'self' : 'cut';
    state.isLocked = false;
    state.addStrips = false;
    if (el.addStrips) el.addStrips.checked = !!state.addStrips;
    ensurePolarisSelectionsState();
    restoreSpotConfig(obj.spotConfig);
    restoreSpotSelections(obj.spotSelections || obj.spotQtyByVariant);
    restoreAccessorySelections(obj.accessorySelections || obj.accessoryQtyByVariant || {});
    saveAccessorySelections();

    state.segmentLenCm = new Map();
    state.centerLenCm = new Map();
    const segLen = obj.segmentLenCm && typeof obj.segmentLenCm === 'object' ? obj.segmentLenCm : {};
    const centerLen = obj.centerLenCm && typeof obj.centerLenCm === 'object' ? obj.centerLenCm : {};
    for (const [k, v] of Object.entries(segLen)) {
      const n = parseCmInput(v);
      if (n != null) state.segmentLenCm.set(k, n);
    }
    for (const [k, v] of Object.entries(centerLen)) {
      const n = parseCmInput(v);
      if (n != null) state.centerLenCm.set(k, n);
    }

    rebuildPoints();
    recomputeDerivedLengthsFromMode();
    resetWorkerState();
    return true;
  }


  async function tryLoadDesignFromUrl() {
    const url = new URL(window.location.href);
    const code = (url.searchParams.get('design') || '').trim().toUpperCase();
    if (!code) return false;
    await loadDesignByCode(code);
    return true;
  }

  function tryLoadCfgFromUrl() {
    const url = new URL(window.location.href);
    const cfgStr = url.searchParams.get('cfg');
    if (!cfgStr) return false;

    try {
      const obj = decodeCfg(cfgStr);
      const ok = applyCfgObject(obj);
      if (ok) lastCfgStr = cfgStr;
      return ok;
    } catch (e) {
      setUrlCfg(null);
      return false;
    }
  }

  async function emailDesignLink() {
    let code = state.designCode;
    let shortUrl = '';

    if (code) {
      shortUrl = getShortDesignUrl(code);
    } else {
      const out = await saveDesignOnServer();
      code = out.code;
      shortUrl = out.shortUrl || getShortDesignUrl(code);
    }

    const link = shortUrl || window.location.href;
    const subject = `Mijn Railspot.nl 3-fase railontwerp ${code || ''}`.trim();
    const body = [
      'Beste,',
      '',
      'Hierbij mijn 3-fase railontwerp:',
      link,
      '',
      code ? `Ontwerpcode: ${code}` : '',
      '',
      'Met vriendelijke groet'
    ].filter((line, index, arr) => line || arr[index - 1] !== '').join('\n');

    focusDesignCode(true);
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setDesignMsg(`E-mailprogramma geopend voor ontwerp ${code || '—'}.`, 'ok');
  }

  // ---------------------------
  // Segment length helpers
  // ---------------------------
  function pruneSegmentLenMap() {
    const existing = new Set(state.segments.map(normSegKey));
    for (const k of Array.from(state.segmentLenCm.keys())) {
      if (!existing.has(k)) state.segmentLenCm.delete(k);
    }
    for (const k of Array.from(state.centerLenCm.keys())) {
      if (!existing.has(k)) state.centerLenCm.delete(k);
    }
  }
  function allSegmentLengthsFilled() {
    const map = getDisplayLengthMap();
    return !!(state.measureMode && state.segments.length > 0 && map && map.size === state.segments.length);
  }

  // ---------------------------
  // Worker (debounced + stale protection)
  // ---------------------------
  let workerTimer = null;
  let workerSeq = 0;

  async function computeViaWorker() {
    if (!WORKER_BASE) throw new Error('Worker URL ontbreekt (section setting).');

    const segLenObj = {};
    for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

    const payload = {
      color: state.color,
      powerKey: state.powerKey,
      segments: state.segments,
      segmentLenCm: segLenObj
    };

    const res = await fetch(WORKER_BASE + '/solve', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const out = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(out?.reason || `Worker error (${res.status})`);
    if (out && out.ok === false) throw new Error(out?.reason || 'Geen resultaat (Worker).');
    return out;
  }

  function scheduleComputeParts() {
    if (!WORKER_BASE) return;
    if (workerTimer) clearTimeout(workerTimer);
    workerTimer = setTimeout(computeParts, 180);
  }

  function resetWorkerState() {
    if (root) root.classList.remove('railcfg--results-ready');
    state.lastWorkerOut = null;
    state.lastParts = null;
    state.lastRailParts = null;
    state.binPlans = null;
    state.lenWarning = false;
    state.lenWarningText = '';
  }

  // ---------------------------
  // Rails UI helpers (optional block)
  // ---------------------------
  function setRailsBlock(open) {
    if (!el.railsBlock || !el.railsToggle) return;
    el.railsBlock.hidden = !open;
    el.railsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function updateRailsToggleState() {
    if (el.railsToggle) {
      el.railsToggle.disabled = !(state.segments && state.segments.length);
    }

    if (el.railsMiniStatus) {
      if (!state.segments.length) el.railsMiniStatus.textContent = 'verplicht';
      else if (countEnteredLengths() > 0) el.railsMiniStatus.textContent = `${countEnteredLengths()}/${state.segments.length} ingevuld`;
      else el.railsMiniStatus.textContent = 'verplicht';
    }

    if (el.railsBlock) {
      el.railsBlock.hidden = false;
    }
  }

  if (el.railsToggle) {
    el.railsToggle.addEventListener('click', () => {
      const isOpen = el.railsBlock && !el.railsBlock.hidden;
      setRailsBlock(!isOpen);
    });
  }
  if (el.railsClose) {
    el.railsClose.addEventListener('click', () => setRailsBlock(false));
  }

  // ---------------------------
  // Cut plan
  // ---------------------------
  function renderCutPlan() {
    const target = el.cutPlan || el.summary;
    if (!target) return;

    if (el.cutPlan) el.cutPlan.innerHTML = '';

    if (!state.binPlans || state.lenWarning || state.segmentLenCm.size === 0) {
      if (el.cutPlan) el.cutPlan.innerHTML = '';
      updateResultsVisibility();
      updateConfidenceUI();
      updateCutPlanToggleUI();
      return;
    }

    const groups = new Map();
    for (const b of state.binPlans) {
      if (!groups.has(b.code)) groups.set(b.code, []);
      groups.get(b.code).push(b);
    }

    const order = (c) => ({ XTS4400: 1, XTS4300: 2, XTS4200: 3, XTS4150: 4, XTS4100: 5 }[c] || 99);
    const codes = Array.from(groups.keys()).sort((a, b) => order(a) - order(b));

    const wrap = document.createElement('div');
    wrap.className = 'railcfg__cutplanInner';

    for (const code of codes) {
      const bins = groups.get(code) || [];
      const rail = document.createElement('section');
      rail.className = 'railcfg__cutplanRail';

      const head = document.createElement('div');
      head.className = 'railcfg__cutplanRailHead';
      head.textContent = `${railLabel(code)} rail (${code}) – ${bins.length}x`;
      rail.appendChild(head);

      const items = document.createElement('div');
      items.className = 'railcfg__cutplanRailItems';

      bins.forEach((b, i) => {
        const line = document.createElement('div');
        line.className = 'railcfg__cutplanRailItem';
        line.textContent = `Rail ${i + 1}: ${b.cutsStr}`;
        items.appendChild(line);
      });

      rail.appendChild(items);
      wrap.appendChild(rail);
    }

    (el.cutPlan || target).appendChild(wrap);
  }

  function getInvalidStraightSplitMessage() {
    return 'Er is iets verkeerd met het tekenen in uw tekening. Begin opnieuw met tekenen.';
  }

  function getRailValidationMessage() {
    if (state.invalidStraightSplit) {
      return state.invalidStraightSplitMessage || getInvalidStraightSplitMessage();
    }
    return '';
  }

  function hasRailValidationError() {
    return !!getRailValidationMessage();
  }

  function hasStrictCollinearOverlap(segA, segB) {
    if (!segA || !segB) return false;

    const bothHorizontal = segA.a.y === segA.b.y && segB.a.y === segB.b.y;
    if (bothHorizontal) {
      if (segA.a.y !== segB.a.y) return false;
      const a1 = Math.min(segA.a.x, segA.b.x);
      const a2 = Math.max(segA.a.x, segA.b.x);
      const b1 = Math.min(segB.a.x, segB.b.x);
      const b2 = Math.max(segB.a.x, segB.b.x);
      return Math.max(a1, b1) < Math.min(a2, b2);
    }

    const bothVertical = segA.a.x === segA.b.x && segB.a.x === segB.b.x;
    if (bothVertical) {
      if (segA.a.x !== segB.a.x) return false;
      const a1 = Math.min(segA.a.y, segA.b.y);
      const a2 = Math.max(segA.a.y, segA.b.y);
      const b1 = Math.min(segB.a.y, segB.b.y);
      const b2 = Math.max(segB.a.y, segB.b.y);
      return Math.max(a1, b1) < Math.min(a2, b2);
    }

    return false;
  }

  function detectInvalidStraightSplit() {
    if (!state.segments.length) return false;

    const nodes = buildNodeMapFromSegments(state.segments);
    for (const [key] of nodes.entries()) {
      if (state.powerKey && key === state.powerKey) continue;
      if (isCollinearDegree2Node(key, nodes)) return true;
    }

    for (let i = 0; i < state.segments.length; i++) {
      for (let j = i + 1; j < state.segments.length; j++) {
        if (hasStrictCollinearOverlap(state.segments[i], state.segments[j])) return true;
      }
    }

    return false;
  }

  function updateInvalidDrawingState() {
    const invalid = detectInvalidStraightSplit();
    state.invalidStraightSplit = invalid;
    state.invalidStraightSplitMessage = invalid ? getInvalidStraightSplitMessage() : '';
  }

  // ---------------------------
  // Compute parts (Worker-only)
  // ---------------------------
  async function computeParts() {
    resetWorkerState();
    setMsg('', null);

    el.partsBody.innerHTML = '';
    if (el.cutPlan) el.cutPlan.innerHTML = '';
    updateResultsVisibility();
    updateConfidenceUI();
    updateCutPlanToggleUI();

    if (!state.segments.length) {
      clearConfigAlert();
      el.summary.textContent = 'Start met tekenen van uw railplan.';
      setDisabledAll(el.btnAddCart, true);
      renderPartsPlaceholder('—');
      return;
    }
    if (hasRailValidationError()) {
      if (root) root.classList.remove('railcfg--results-ready');
      const msg = getRailValidationMessage();
      setConfigAlert(msg);
      el.summary.textContent = msg;
      setDisabledAll(el.btnAddCart, true);
      renderPartsPlaceholder('Begin opnieuw met tekenen.');
      return;
    }
    if (!state.color) {
      setConfigAlert('Kies eerst een railkleur om verder te gaan.');
      el.summary.textContent = 'Kies eerst een railkleur.';
      setDisabledAll(el.btnAddCart, true);
      renderPartsPlaceholder('Kies eerst een railkleur.');
      return;
    }
    if (!WORKER_BASE) {
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('De configurator is nog niet volledig ingesteld. Neem contact met ons op als dit probleem zichtbaar blijft.');
      el.summary.textContent = 'Worker URL ontbreekt (vul in bij section settings).';
      setDisabledAll(el.btnAddCart, true);
      renderPartsPlaceholder('—');
      return;
    }

    if (!state.powerKey) {
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('Kies eerst het stroompunt voordat de complete set kan worden berekend.');
      el.summary.textContent = 'Plaats eerst de voeding op het gewenste punt.';
      setDisabledAll(el.btnAddCart, true);
      renderPartsPlaceholder('Plaats eerst de voeding op het gewenste punt.');
      return;
    }

    if (!state.measureMode) {
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('Kies eerst of u hartmaten of railmaten wilt gebruiken.');
      el.summary.textContent = 'Kies eerst of u met hartmaten of railmaten werkt.';
      setDisabledAll(el.btnAddCart, true);
      renderPartsPlaceholder('Kies eerst uw meetmethode.');
      return;
    }

    if (state.segmentLenCm.size !== state.segments.length) {
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('Vul eerst alle rechte railmaten in om uw complete railset te berekenen.');
      el.summary.textContent = 'Vul nu alle rechte railmaten in voor de complete berekening.';
      setDisabledAll(el.btnAddCart, true);
      renderPartsPlaceholder('Vul nu alle maten in.');
      return;
    }

    const mySeq = ++workerSeq;
    clearConfigAlert();
    setDisabledAll(el.btnAddCart, true);
    el.summary.textContent = 'Uw complete railset wordt berekend…';
    renderPartsPlaceholder('Onderdelen worden berekend…');

    try {
      const out = await computeViaWorker();
      if (mySeq !== workerSeq) return;

      state.lastWorkerOut = out;
      state.lastParts = new Map(Object.entries(out.parts || {}).map(([k, v]) => [k, Number(v) || 0]));

      const rails = out.rails || {};
      state.lenWarning = !!rails.lenWarning;
      state.lenWarningText = rails.lenWarningText || '';

      state.lastRailParts = new Map(Object.entries(rails.railParts || {}).map(([k, v]) => [k, Number(v) || 0]));
      state.binPlans = Array.isArray(rails.binPlans) ? rails.binPlans : null;

      el.summary.innerHTML = '';
      if (rails.enabled && state.lenWarning) {
        const warn = document.createElement('div');
        warn.style.color = '#b00020';
        warn.textContent = state.lenWarningText || 'Vul alle raillengtes in (cm) of laat alles leeg.';
        el.summary.appendChild(warn);
      } else {
        const ok = document.createElement('div');
        ok.style.color = '#116b2a';
        ok.textContent = '✔ Uw complete railset is klaar om te bestellen.';
        el.summary.appendChild(ok);
      }

      updateStripsUI();
      const groups = buildPartsGroups();

      if (root) root.classList.add('railcfg--results-ready');

      if (!groups.length) {
        renderPartsPlaceholder('Geen onderdelen gevonden.');
        updateResultsVisibility();
        setDisabledAll(el.btnAddCart, true);
        return;
      }

      renderPartsGroups(groups);
      renderCutPlan();
      updateResultsVisibility();
      updateConfidenceUI();
      updateCutPlanToggleUI();
      clearConfigAlert();
      setDisabledAll(el.btnAddCart, false);

    } catch (e) {
      if (mySeq !== workerSeq) return;
      if (root) root.classList.remove('railcfg--results-ready');
      setConfigAlert('Er is iets misgegaan bij het berekenen van uw configuratie. Probeer het opnieuw.');
      el.summary.textContent = 'Worker fout: ' + (e?.message || e);
      setDisabledAll(el.btnAddCart, true);
      renderPartsPlaceholder('Onderdelen konden niet worden geladen.');
      if (el.cutPlan) el.cutPlan.innerHTML = '';
      updateResultsVisibility();
      updateConfidenceUI();
      updateCutPlanToggleUI();
    }
  }

  // ---------------------------
  // SVG render
  // ---------------------------
  function clearSvgOnly() { while (el.svg.firstChild) el.svg.removeChild(el.svg.firstChild); }

  function drawGrid() {
    const w = 1000, h = 600;
    const step = SNAP_CM * unitPerCm();

    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    g.setAttribute('opacity', '0.22');

    for (let x = 0; x <= w; x += step) {
      const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l.setAttribute('x1', x); l.setAttribute('y1', 0);
      l.setAttribute('x2', x); l.setAttribute('y2', h);
      l.setAttribute('stroke', '#ddd'); l.setAttribute('stroke-width', '1');
      g.appendChild(l);
    }
    for (let y = 0; y <= h; y += step) {
      const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l.setAttribute('x1', 0); l.setAttribute('y1', y);
      l.setAttribute('x2', w); l.setAttribute('y2', y);
      l.setAttribute('stroke', '#ddd'); l.setAttribute('stroke-width', '1');
      g.appendChild(l);
    }
    el.svg.appendChild(g);
  }

  function drawSegments() {
    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    for (const seg of state.segments) {
      const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l.setAttribute('x1', seg.a.x); l.setAttribute('y1', seg.a.y);
      l.setAttribute('x2', seg.b.x); l.setAttribute('y2', seg.b.y);
      l.setAttribute('stroke', '#111');
      l.setAttribute('stroke-width', '10');
      l.setAttribute('stroke-linecap', 'round');
      g.appendChild(l);
    }
    el.svg.appendChild(g);
  }

function drawTag(g, x, y, text) {
  const isMobile = window.innerWidth <= 768;

  const fontSize = isMobile ? 18 : 14;
  const padX = isMobile ? 10 : 10;
  const padY = isMobile ? 6 : 6;
  const charW = fontSize * 0.62;

  const w = Math.max(isMobile ? 44 : 34, Math.ceil(text.length * charW + padX * 2));
  const h = Math.ceil(fontSize + padY * 2);

  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('x', String(x - w / 2));
  rect.setAttribute('y', String(y - h / 2));
  rect.setAttribute('rx', isMobile ? '8' : '6');
  rect.setAttribute('ry', isMobile ? '8' : '6');
  rect.setAttribute('width', String(w));
  rect.setAttribute('height', String(h));
  rect.setAttribute('fill', '#ffffff');
  rect.setAttribute('fill-opacity', '0.92');
  rect.setAttribute('stroke', 'none');
  rect.setAttribute('filter', 'drop-shadow(0 1px 2px rgba(0,0,0,0.15))');

  const t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  t.setAttribute('x', String(x));
  t.setAttribute('y', String(y + (isMobile ? 6 : 4)));
  t.setAttribute('text-anchor', 'middle');
  t.setAttribute('font-family', 'Arial, sans-serif');
  t.setAttribute('font-size', String(fontSize));
  t.setAttribute('font-weight', isMobile ? '700' : '600');
  t.setAttribute('fill', '#111');
  t.textContent = text;

  g.appendChild(rect);
  g.appendChild(t);
}

  function drawSegmentIndexLabels() {
    if (!state.segments.length) return;
    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    state.segments.forEach((seg, i) => {
      const m = segmentMidpoint(seg);
      const o = segmentLabelOffset(seg);
      drawTag(g, m.x + o.ox, m.y + o.oy, `S${i + 1}`);
    });
    el.svg.appendChild(g);
  }

  function drawSegmentLengthLabels() {
    if (!allSegmentLengthsFilled()) return;

    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    for (const seg of state.segments) {
      const key = normSegKey(seg);
      const cm = getDisplayLengthMap().get(key);
      if (!(typeof cm === 'number' && isFinite(cm) && cm > 0)) continue;

      const m = segmentMidpoint(seg);
      const o = segmentLabelOffset(seg);
      drawTag(g, m.x + o.ox * 1.8, m.y + o.oy * 1.8, `${formatCmValue(cm)} cm`);
    }
    el.svg.appendChild(g);
  }

  function drawNodes() {
    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');

    for (const p of state.points) {
      const key = pointKey(p);

      const hit = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      hit.setAttribute('cx', p.x);
      hit.setAttribute('cy', p.y);
      hit.setAttribute('r', '22');
      hit.setAttribute('fill', 'transparent');
      hit.setAttribute('data-node-key', key);
      hit.style.pointerEvents = 'all';

      const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('cx', p.x);
      c.setAttribute('cy', p.y);
      c.setAttribute('r', '6');
      c.setAttribute('fill', '#fff');
      c.setAttribute('stroke', '#111');
      c.setAttribute('stroke-width', '2');
      c.setAttribute('data-node-key', key);
      c.style.pointerEvents = 'none';

      g.appendChild(hit);
      g.appendChild(c);
    }

    el.svg.appendChild(g);
  }

  function drawPowerMarker() {
    if (!state.powerKey) return;
    const [x, y] = state.powerKey.split(',').map(Number);

    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');

    const halo = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    halo.setAttribute('cx', x); halo.setAttribute('cy', y);
    halo.setAttribute('r', '16');
    halo.setAttribute('fill', 'none');
    halo.setAttribute('stroke', '#111');
    halo.setAttribute('stroke-width', '3');
    halo.setAttribute('stroke-dasharray', '6 6');

    const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    dot.setAttribute('cx', x); dot.setAttribute('cy', y);
    dot.setAttribute('r', '7');
    dot.setAttribute('fill', '#111');

    g.appendChild(halo);
    g.appendChild(dot);
    el.svg.appendChild(g);
  }

  // ---------------------------
  // Graph building
  // ---------------------------
  function pushSeg(a, b) {
    if (samePoint(a, b)) return;
    if (!(a.x === b.x || a.y === b.y)) return;

    const exists = state.segments.some(s =>
      (samePoint(s.a, a) && samePoint(s.b, b)) || (samePoint(s.a, b) && samePoint(s.b, a))
    );
    if (exists) return;

    state.segments.push({ a, b });
  }

  function uniquePoints(points) {
    const m = new Map();
    points.forEach(p => m.set(`${p.x},${p.y}`, p));
    return Array.from(m.values());
  }

  function sortPointsOnSeg(points, seg) {
    const s = normSeg(seg);
    const pts = points.slice();
    if (s.ori === 'H') pts.sort((p, q) => p.x - q.x);
    else pts.sort((p, q) => p.y - q.y);
    return pts;
  }

  function isCollinearDegree2Node(nodeKeyStr, nodes) {
    const node = nodes.get(nodeKeyStr);
    if (!node || node.incident.length !== 2) return false;

    const d1 = node.incident[0].dir;
    const d2 = node.incident[1].dir;

    return (
      (d1 === 'N' && d2 === 'S') || (d1 === 'S' && d2 === 'N') ||
      (d1 === 'E' && d2 === 'W') || (d1 === 'W' && d2 === 'E')
    );
  }

  function buildNodeMapFromSegments(segments) {
    const nodes = new Map();

    function addNode(p) {
      const k = pointKey(p);
      if (!nodes.has(k)) nodes.set(k, { p, incident: [] });
      return nodes.get(k);
    }

    function dirOf(a, b) {
      if (a.x === b.x) return (b.y > a.y) ? 'S' : 'N';
      return (b.x > a.x) ? 'E' : 'W';
    }

    for (const seg of segments) {
      const na = addNode(seg.a);
      const nb = addNode(seg.b);
      na.incident.push({ dir: dirOf(seg.a, seg.b), other: pointKey(seg.b) });
      nb.incident.push({ dir: dirOf(seg.b, seg.a), other: pointKey(seg.a) });
    }

    return nodes;
  }

  function mergeRedundantStraightNodes() {
    let changed = true;

    while (changed) {
      changed = false;
      const nodes = buildNodeMapFromSegments(state.segments);

      for (const [key, node] of nodes.entries()) {
        // actieve middenvoeding nooit weg-mergen
       if (state.powerKey) {
  if (key === state.powerKey) continue;

  const node = nodes.get(key);
  if (node) {
    const touchesPower = node.incident.some(i => i.other === state.powerKey);
    if (touchesPower) continue;
  }
}

        if (!isCollinearDegree2Node(key, nodes)) continue;

        const otherA = parsePointKey(node.incident[0].other);
        const otherB = parsePointKey(node.incident[1].other);
        const self = parsePointKey(key);

        if (!otherA || !otherB || !self) continue;

        // zoek exact de 2 segmenten die op deze node aansluiten
        const hitIdx = [];
        for (let i = 0; i < state.segments.length; i++) {
          const s = state.segments[i];
          if (
            samePoint(s.a, self) || samePoint(s.b, self)
          ) {
            hitIdx.push(i);
          }
        }

        if (hitIdx.length !== 2) continue;

        const idxDesc = hitIdx.sort((a, b) => b - a);
        state.segments.splice(idxDesc[0], 1);
        state.segments.splice(idxDesc[1], 1);

        pushSeg(otherA, otherB);

        changed = true;
        break;
      }
    }
  }

  function parsePointKey(key) {
    const parts = String(key).split(',');
    if (parts.length !== 2) return null;

    const x = Number(parts[0]);
    const y = Number(parts[1]);

    if (!isFinite(x) || !isFinite(y)) return null;
    return { x, y };
  }

function parsePointKey(key) {
  const parts = String(key).split(',');
  if (parts.length !== 2) return null;
  const x = Number(parts[0]);
  const y = Number(parts[1]);
  if (!isFinite(x) || !isFinite(y)) return null;
  return { x, y };
}

function buildNodeMapFromSegments(segments) {
  const nodes = new Map();

  function addNode(p) {
    const k = pointKey(p);
    if (!nodes.has(k)) nodes.set(k, { p, incident: [] });
    return nodes.get(k);
  }

  function dirOf(a, b) {
    if (a.x === b.x) return (b.y > a.y) ? 'S' : 'N';
    return (b.x > a.x) ? 'E' : 'W';
  }

  for (const seg of segments) {
    const na = addNode(seg.a);
    const nb = addNode(seg.b);
    na.incident.push({ dir: dirOf(seg.a, seg.b), other: pointKey(seg.b) });
    nb.incident.push({ dir: dirOf(seg.b, seg.a), other: pointKey(seg.a) });
  }

  return nodes;
}

function isCollinearDegree2Node(nodeKeyStr, nodes) {
  const node = nodes.get(nodeKeyStr);
  if (!node || node.incident.length !== 2) return false;

  const d1 = node.incident[0].dir;
  const d2 = node.incident[1].dir;

  return (
    (d1 === 'N' && d2 === 'S') || (d1 === 'S' && d2 === 'N') ||
    (d1 === 'E' && d2 === 'W') || (d1 === 'W' && d2 === 'E')
  );
}

function mergeRedundantStraightNodes() {
  let changed = true;

  while (changed) {
    changed = false;
    const nodes = buildNodeMapFromSegments(state.segments);

    for (const [key, node] of nodes.entries()) {
      // actieve middenvoeding nooit weg-mergen
      if (state.powerKey && key === state.powerKey) continue;

      if (!isCollinearDegree2Node(key, nodes)) continue;

      const self = parsePointKey(key);
      const otherA = parsePointKey(node.incident[0].other);
      const otherB = parsePointKey(node.incident[1].other);

      if (!self || !otherA || !otherB) continue;

      const hitIdx = [];
      for (let i = 0; i < state.segments.length; i++) {
        const s = state.segments[i];
        if (samePoint(s.a, self) || samePoint(s.b, self)) hitIdx.push(i);
      }

      if (hitIdx.length !== 2) continue;

      const idxDesc = hitIdx.sort((a, b) => b - a);
      state.segments.splice(idxDesc[0], 1);
      state.segments.splice(idxDesc[1], 1);
      pushSeg(otherA, otherB);

      changed = true;
      break;
    }
  }
}

function rebuildPoints() {
  mergeRedundantStraightNodes();

  const pts = [];
  const add = (p) => { if (!pts.some(q => samePoint(p, q))) pts.push(p); };

  state.segments.forEach(s => { add(s.a); add(s.b); });
  state.points = pts;

  if (state.powerKey) {
    const exists = state.points.some(p => pointKey(p) === state.powerKey);
    if (!exists) state.powerKey = null;
  }

  pruneSegmentLenMap();
  recomputeDerivedLengthsFromMode();
  updateInvalidDrawingState();
}

function splitSegmentAtIndex(idx, p, opts = {}) {
  const seg = state.segments[idx];
  if (!seg) return false;
  if (samePoint(p, seg.a) || samePoint(p, seg.b)) return false;

  state.segments.splice(idx, 1);
  pushSeg(seg.a, p);
  pushSeg(p, seg.b);

  if (!opts.skipRebuild) rebuildPoints();
  return true;
}
function tryPickPowerOnSegment(evt) {
  const raw = svgPointFromEvent(evt);
  const p = { x: raw.x, y: raw.y };

  const THRESH = 14;
  let bestIdx = -1;
  let bestDist = Infinity;

  for (let i = 0; i < state.segments.length; i++) {
    const d = distPointToSeg(p, state.segments[i]);
    if (d < bestDist) {
      bestDist = d;
      bestIdx = i;
    }
  }

  if (bestIdx === -1 || bestDist > THRESH) return false;

  const q = closestPointOnSegSnapped(p, state.segments[bestIdx]);
  if (!onSegment(q, state.segments[bestIdx])) return false;

  const qKey = pointKey(q);

  // klik exact op bestaand punt
  if (state.points.some(pt => pointKey(pt) === qKey)) {
    state.powerKey = qKey;
    state.pickPowerMode = false;
    rebuildPoints();
    return true;
  }

  // eerst fysiek splitten, maar nog niet rebuilden
  if (!splitSegmentAtIndex(bestIdx, q, { skipRebuild: true })) return false;

  // nu pas de nieuwe node als actief stroompunt zetten
  state.powerKey = qKey;
  state.pickPowerMode = false;

  // daarna rebuilden, zodat deze node beschermd blijft
  rebuildPoints();
  setDesignCode(null);
  return true;
}

  function segIntersection(seg1, seg2) {
    const s1 = normSeg(seg1), s2 = normSeg(seg2);
    if (s1.ori === s2.ori) {
      const pts = [s1.a, s1.b];
      for (const p of pts) if (onSegment(p, seg2)) return { x: p.x, y: p.y };
      const pts2 = [s2.a, s2.b];
      for (const p of pts2) if (onSegment(p, seg1)) return { x: p.x, y: p.y };
      return null;
    }
    const h = (s1.ori === 'H') ? s1 : s2;
    const v = (s1.ori === 'V') ? s1 : s2;
    const p = { x: v.a.x, y: h.a.y };
    if (p.x >= h.a.x && p.x <= h.b.x && p.y >= v.a.y && p.y <= v.b.y) return p;
    return null;
  }

  function addSegment(a, b) {
    if (samePoint(a, b)) return;
    const newSeg = { a, b };

    let splitPointsNew = [a, b];
    const splitsForExisting = new Map();

    state.segments.forEach((seg, idx) => {
      const ip = segIntersection(newSeg, seg);
      if (!ip) return;
      splitPointsNew.push(ip);
      if (onSegment(ip, seg)) {
        if (!splitsForExisting.has(idx)) splitsForExisting.set(idx, []);
        splitsForExisting.get(idx).push(ip);
      }
    });

    splitPointsNew = uniquePoints(splitPointsNew);

    const indices = Array.from(splitsForExisting.keys()).sort((x, y) => y - x);
    indices.forEach(idx => {
      const seg = state.segments[idx];
      let pts = uniquePoints(splitsForExisting.get(idx) || []);
      const endpoints = [seg.a, seg.b];
      pts = pts.filter(p => !endpoints.some(e => samePoint(e, p)));
      if (!pts.length) return;

      state.segments.splice(idx, 1);

      const allPts = uniquePoints([seg.a, seg.b, ...pts]);
      const ordered = sortPointsOnSeg(allPts, seg);
      for (let i = 0; i < ordered.length - 1; i++) pushSeg(ordered[i], ordered[i + 1]);
    });

    const orderedNew = sortPointsOnSeg(splitPointsNew, newSeg);
    for (let i = 0; i < orderedNew.length - 1; i++) pushSeg(orderedNew[i], orderedNew[i + 1]);

    rebuildPoints();
    setDesignCode(null);
  }

  // ---------------------------
  // Segment length table
  // ---------------------------
  function renderSegmentTable() {
    if (!el.segTableBody) return;

    pruneSegmentLenMap();
    recomputeDerivedLengthsFromMode();
    el.segTableBody.innerHTML = '';

    if (!state.segments.length) {
      const tr = document.createElement('tr');
      tr.innerHTML = `<td colspan="3" style="color:#666;font-size:12px;padding:8px 6px">Teken eerst segmenten.</td>`;
      el.segTableBody.appendChild(tr);
      return;
    }

    state.segments.forEach((seg, i) => {
      const key = normSegKey(seg);
      const railVal = state.segmentLenCm.get(key);
      const hartVal = state.centerLenCm.get(key);
      const hasMode = !!state.measureMode;
      const isRailMode = state.measureMode === 'rail';
      const isHartMode = state.measureMode === 'hart';

      const tr = document.createElement('tr');
      tr.innerHTML = `
        <td>S${i + 1}</td>
        <td>
          <input class="railcfg__segInput ${isRailMode ? '' : 'is-readonly'}" inputmode="decimal" pattern="[0-9]+([\.,][0-9])?"
                 placeholder="${hasMode ? '(leeg)' : 'Kies eerst'}" data-segkey="${key}" data-len-type="rail" ${isRailMode ? '' : 'disabled tabindex="-1" aria-disabled="true"'} value="${formatCmValue(railVal)}">
        </td>
        <td>
          <input class="railcfg__segInput ${isHartMode ? '' : 'is-readonly'}" inputmode="decimal" pattern="[0-9]+([\.,][0-9])?"
                 placeholder="${hasMode ? '(leeg)' : 'Kies eerst'}" data-segkey="${key}" data-len-type="hart" ${isHartMode ? '' : 'disabled tabindex="-1" aria-disabled="true"'} value="${formatCmValue(hartVal)}">
        </td>
      `;
      el.segTableBody.appendChild(tr);
    });

    const activeInputs = Array.from(
      el.segTableBody.querySelectorAll('input[data-segkey]:not(:disabled)')
    );

    function focusNextActiveInput(currentInput, direction) {
      const idx = activeInputs.indexOf(currentInput);
      if (idx === -1) return false;

      const next = activeInputs[idx + direction];
      if (!next) return false;

      try {
        next.focus();
        next.select();
      } catch (e) {}
      return true;
    }

    activeInputs.forEach((inp) => {
      inp.addEventListener('focus', () => {
        window.requestAnimationFrame(() => {
          try { inp.select(); } catch (e) {}
        });
      });

      inp.addEventListener('click', () => {
        if (document.activeElement !== inp) return;
        try { inp.select(); } catch (e) {}
      });

      inp.addEventListener('input', () => {
        const key = inp.getAttribute('data-segkey');
        const type = inp.getAttribute('data-len-type');
        const raw = String(inp.value || '').trim();

        if (type === 'rail') {
          if (!raw) state.segmentLenCm.delete(key);
          else {
            const n = parseCmInput(raw);
            if (n != null) state.segmentLenCm.set(key, n);
            else state.segmentLenCm.delete(key);
          }
        } else {
          if (!raw) state.centerLenCm.delete(key);
          else {
            const n = parseCmInput(raw);
            if (n != null) state.centerLenCm.set(key, n);
            else state.centerLenCm.delete(key);
          }
        }

        recomputeDerivedLengthsFromMode();
        setDesignCode(null);
        scheduleComputeParts();

        if (el.railsBlock && el.railsToggle) {
          if (countEnteredLengths() > 0) setRailsBlock(true);
          else setRailsBlock(false);
        }
        updateRailsToggleState();
      });

      inp.addEventListener('blur', render);
      inp.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (!focusNextActiveInput(inp, 1)) inp.blur();
          return;
        }

        if (e.key === 'Tab') {
          const moved = focusNextActiveInput(inp, e.shiftKey ? -1 : 1);
          if (moved) e.preventDefault();
        }
      });
    });

    updateMeasureModeUI();
  }

  function syncButtons() {
    const hasAny = state.segments.length > 0;
    const locked = !!state.isLocked;

    // Pick power
    el.btnPickPower.forEach((btn) => {
      btn.disabled = !hasAny;
      if (state.pickPowerMode) btn.textContent = 'Klik punt/segment…';
      else if (btn.dataset.defaultLabel) btn.textContent = btn.dataset.defaultLabel;
    });

    // Clear power
    el.btnClearPower.forEach((btn) => {
      btn.disabled = !state.powerKey;
    });

    // Lock buttons
    el.btnLocks.forEach((btn) => {
      const isLocked = !!state.isLocked;
      btn.classList.toggle('is-locked', isLocked);
      btn.classList.toggle('is-unlocked', !isLocked);
      if (!btn.querySelector('.lock-icon')) {
        btn.innerHTML = '<span class="lock-icon"></span>';
      }
      btn.setAttribute('aria-label', isLocked ? 'Ontwerp vergrendeld' : 'Ontwerp bewerkbaar');
      btn.setAttribute('title', isLocked ? 'Ontwerp vergrendeld' : 'Ontwerp bewerkbaar');
    });

    // Klaar met tekenen buttons
    el.btnFinishDraw.forEach((btn) => {
      btn.disabled = !hasAny || hasRailValidationError();
      btn.classList.toggle('is-locked', locked);
    });

    // Sidebar power status
    if (el.powerStatus) {
      el.powerStatus.textContent = state.powerKey ? 'Gekozen' : 'Niet gekozen';
    }
  }

  function updateCanvasStatus() {
    if (!el.statusText) return;

    if (hasRailValidationError() && state.segments.length) {
      el.statusText.textContent = getRailValidationMessage();
      return;
    }

    if (!state.segments.length) {
      el.statusText.textContent = 'Klik om te starten — teken het bovenaanzicht horizontaal of verticaal';
      return;
    }
    if (!state.color) {
      el.statusText.textContent = state.isLocked
        ? 'Tekening vergrendeld — kies nu uw railkleur'
        : 'Tekening gereed — kies nu uw railkleur';
      return;
    }
    if (state.pickPowerMode) {
      el.statusText.textContent = 'Plaats het stroompunt — klik op een eindpunt of rechte rail';
      return;
    }
    if (!state.powerKey) {
      el.statusText.textContent = 'Railkleur gekozen — plaats nu het stroompunt (scroll naar stap 3)';
      return;
    }
    if (!state.measureMode) {
      el.statusText.textContent = 'Stroompunt geplaatst — kies nu eerst hartmaat of railmaat in stap 4';
      return;
    }
    if (state.segmentLenCm.size !== state.segments.length) {
      el.statusText.textContent = 'Stroompunt geplaatst — vul nu alle maten in (scroll naar stap 4)';
      return;
    }

    el.statusText.textContent = '✔ Ontwerp compleet — alle onderdelen zijn correct bepaald';
  }

  function updateStepStates() {
    if (!el.stepItems || !el.stepItems.length) return;

    const step1Done = !!state.color;
    const step2Done = state.segments.length > 0;
    const step3Done = !!state.powerKey;
    const step4Done = state.segments.length > 0 && !!state.measureMode && state.segmentLenCm.size === state.segments.length;
    const step5Done = Array.from(state.spotQtyByVariant.values()).some((qty) => clampSpotQty(qty) > 0);

    el.stepItems.forEach((item) => {
      const idx = Number(item.getAttribute('data-step-index') || 0);
      item.classList.remove('railcfg__step--todo', 'railcfg__step--active', 'railcfg__step--done');

      const isDone =
        (idx === 1 && step1Done) ||
        (idx === 2 && step2Done) ||
        (idx === 3 && step3Done) ||
        (idx === 4 && step4Done) ||
        (idx === 5 && step5Done);

      let isActive = false;
      if (!step1Done && idx === 1) isActive = true;
      else if (step1Done && !step2Done && idx === 2) isActive = true;
      else if (step2Done && !step3Done && idx === 3) isActive = true;
      else if (step3Done && !step4Done && idx === 4) isActive = true;
      else if (step4Done && !step5Done && idx === 5) isActive = true;

      if (isDone && !isActive) item.classList.add('railcfg__step--done');
      else if (isActive) item.classList.add('railcfg__step--active');
      else item.classList.add('railcfg__step--todo');
    });
  }

  function render() {
    clearSvgOnly();
    drawGrid();
    drawSegments();
    drawSegmentIndexLabels();
    drawNodes();
    drawPowerMarker();
    drawSegmentLengthLabels();
    renderSegmentTable();
    updateColorUI();
    updateStripsUI();
    updateSpotsUI();
    updateAccessoriesUI();
    updateOfferButtonVisibility();
    updateMeasureModeUI();
    updateRailModeUI();
    syncButtons();
    updateLockUI();
    updateCanvasStatus();
    syncRailValidationAlert();
    updateStepStates();
    updateResultsVisibility();
    updateConfidenceUI();
    updateCutPlanToggleUI();
    scheduleComputeParts();
    scheduleShareUpdate();
    updateRailsToggleState();
    saveAutosave();
  }

  // ---------------------------
  // Drawing interactions
  // ---------------------------
  const drawing = { active: false, start: null, previewLine: null };

  function startPreview(a) {
    const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    l.setAttribute('x1', a.x); l.setAttribute('y1', a.y);
    l.setAttribute('x2', a.x); l.setAttribute('y2', a.y);
    l.setAttribute('stroke', '#666');
    l.setAttribute('stroke-width', '6');
    l.setAttribute('stroke-linecap', 'round');
    l.setAttribute('stroke-dasharray', '10 8');
    el.svg.appendChild(l);
    drawing.previewLine = l;
  }

  function updatePreview(to) {
    if (!drawing.previewLine || !drawing.start) return;
    const seg = normalizeSegment(drawing.start, to);
    drawing.previewLine.setAttribute('x2', seg.b.x);
    drawing.previewLine.setAttribute('y2', seg.b.y);
  }

  function stopPreview() {
    if (drawing.previewLine) {
      drawing.previewLine.remove();
      drawing.previewLine = null;
    }
  }

  function onPointerDown(evt) {
    evt.preventDefault();

    if (state.pickPowerMode) {
      const elNode = evt.target && evt.target.closest ? evt.target.closest('[data-node-key]') : null;
      const key = elNode ? elNode.getAttribute('data-node-key') : null;

if (key) {
  state.powerKey = key;
  state.pickPowerMode = false;
  rebuildPoints();
  setDesignCode(null);
  render();
  return;
}

      if (tryPickPowerOnSegment(evt)) render();
      return;
    }

    if (!isEditable()) return;

    const p0 = svgPointFromEvent(evt);
    const p = { x: snap(p0.x), y: snap(p0.y) };

    if (!drawing.active) {
  clearConfigAlert();
  // Leeg ontwerp: eerste lijn mag overal starten
  if (!state.segments.length) {
    drawing.active = true;
    drawing.start = p;
    startPreview(p);
    if (!state.points.some(q => samePoint(p, q))) state.points.push(p);
    render();
    return;
  }

  // Bestaand ontwerp: alleen starten vanaf bestaand punt
  const existingPoint = state.points.find(q => samePoint(q, p));
  if (!existingPoint) {
    setConfigAlert('Wilt u verder tekenen? Klik dan op een bestaand eindpunt van het bovenaanzicht.');
    setMsg('Wilt u verder tekenen? Klik dan op een bestaand eindpunt van het bovenaanzicht.', 'err');
    return;
  }

  drawing.active = true;
  drawing.start = existingPoint;
  startPreview(existingPoint);
  render();
  return;
}

    const seg = normalizeSegment(drawing.start, p);
    addSegment(seg.a, seg.b);

    drawing.start = seg.b;
    stopPreview();
    startPreview(drawing.start);

    render();
  }

  function onPointerMove(evt) {
    if (!isEditable()) return;
    if (!drawing.active || state.pickPowerMode) return;
    const p0 = svgPointFromEvent(evt);
    const p = { x: snap(p0.x), y: snap(p0.y) };
    updatePreview(p);
  }

  function undo() {
    if (!state.segments.length) return;

    state.segments.pop();
    rebuildPoints();
    setDesignCode(null);

    if (!state.segments.length) {
      drawing.active = false;
      drawing.start = null;
      stopPreview();
      state.powerKey = null;
      state.pickPowerMode = false;
      state.segmentLenCm.clear();
      state.centerLenCm.clear();
    }
    render();
  }

  function clearAll() {
    clearConfigAlert();
    state.points = [];
    state.segments = [];
    state.powerKey = null;
    state.pickPowerMode = false;
    state.color = null;
    state.designCode = null;
    state.isLocked = false;
    drawing.active = false;
    drawing.start = null;
    stopPreview();
    state.segmentLenCm.clear();
    state.centerLenCm.clear();
    state.spotQtyByVariant.clear();
    state.polarisSelections = {};
    ensurePolarisSelectionsState();
    state.accessoryQtyByVariant.clear();
    saveAccessorySelections();
    state.addStrips = false;
    state.cutPlanOpen = false;
    resetWorkerState();
    if (el.addStrips) el.addStrips.checked = false;
    setMsg('', null);
    setDesignMsg('', null);
    setDesignCode(null);
    clearAutosave();
    render();
  }

  // ---------------------------
  // Add to cart (rails per bin met zaagmaat)
  // ---------------------------
  function partsToCartItems() {
    if (!state.lastParts) return { ok: false, reason: 'Geen onderdelen om toe te voegen.' };

    const map = VARIANTS[state.color];
    if (!map) return { ok: false, reason: 'Kleurmapping ontbreekt.' };

    const railItems = [];
        const otherItems = [];

    function makeItem(code, qty, properties) {
      if (!qty || qty <= 0) return { ok: true, item: null };
      const variantId = map[code];
      if (!variantId) {
        return {
          ok: false,
          reason: `Geen Variant ID gevonden voor ${code} (${state.color}).`
        };
      }

      const obj = { id: variantId, quantity: qty };
      const mergedProps = Object.assign({}, properties || {});
      if (state.designCode) mergedProps.Ontwerpcode = state.designCode;
      if (Object.keys(mergedProps).length) obj.properties = mergedProps;
      return { ok: true, item: obj };
    }

    function pushTo(list, code, qty, properties) {
      const result = makeItem(code, qty, properties);
      if (!result.ok) return result;
      if (result.item) list.push(result.item);
      return { ok: true };
    }

    function buildGroupedRailCutLabel(cutsStr, qty) {
      const safeQty = Math.max(1, Number(qty) || 1);
      const raw = String(cutsStr || '').trim();
      if (!raw) return '';
      if (safeQty === 1) return raw;
      if (raw === 'Hele rail (niet zagen)') return raw;

      const parts = raw
        .split('|')
        .map((part) => String(part || '').trim())
        .filter(Boolean)
        .map((part) => {
          const match = part.match(/^(\d+)x\s+(.+)$/i);
          if (!match) return part;
          const baseQty = Number(match[1]) || 0;
          const label = String(match[2] || '').trim();
          if (!baseQty || !label) return part;
          return `${baseQty * safeQty}x ${label}`;
        });

      return parts.join(' | ');
    }

    // Rails apart verzamelen zodat ze zichtbaar bovenaan in de cart komen.
    if (state.binPlans && !state.lenWarning) {
      const groupedRails = new Map();

      for (const b of state.binPlans) {
        const code = String(b.code || '').trim();
        const cutsStr = String(b.cutsStr || '').trim();
        const groupKey = `${code}__${cutsStr}`;

        if (!groupedRails.has(groupKey)) {
          groupedRails.set(groupKey, { code, cutsStr, qty: 0 });
        }

        groupedRails.get(groupKey).qty += 1;
      }

      for (const group of groupedRails.values()) {
        const properties = {};
        const groupedCutLabel = buildGroupedRailCutLabel(group.cutsStr, group.qty);
        if (state.railMode !== 'self' && groupedCutLabel) properties.zaagmaat = groupedCutLabel;

        const result = pushTo(railItems, group.code, group.qty, properties);
        if (!result.ok) return result;
      }
    }

    // Overige configurator-onderdelen.
    for (const code of ['XTS11', 'XTS12', 'XTS14']) {
      const result = pushTo(otherItems, code, state.lastParts.get(code) || 0);
      if (!result.ok) return result;
    }

    for (const code of ['XTS34', 'XTS35', 'XTS36', 'XTS37', 'XTS39', 'XTS40', 'XTS38']) {
      const result = pushTo(otherItems, code, state.lastParts.get(code) || 0);
      if (!result.ok) return result;
    }

    if (state.lastRailParts && !state.lenWarning) {
      const result = pushTo(otherItems, 'XTS21', state.lastRailParts.get('XTS21') || 0);
      if (!result.ok) return result;
    }

    {
      const result = pushTo(otherItems, 'XTS41', state.lastParts.get('XTS41') || 0);
      if (!result.ok) return result;
    }

    const visibleItems = [
      ...railItems,
      ...otherItems
    ];

    if (!visibleItems.length) return { ok: false, reason: 'Geen onderdelen om toe te voegen.' };

    // Shopify toont nieuw toegevoegde regels bovenaan.
    // Daarom sturen we de configurator-items in omgekeerde volgorde,
    // zodat de zichtbare volgorde in de cart wordt:
    // 1. rails
    // 2. overige configurator-onderdelen
    return { ok: true, items: visibleItems.slice().reverse() };
  }

  async function addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      let txt = '';
      try { txt = await res.text(); } catch (e) {}
      throw new Error('Cart add failed: ' + (txt || res.status));
    }
    return await res.json();
  }

  async function handleAddCartClick() {
    setMsg('', null);

    if (hasRailValidationError()) {
      const msg = getRailValidationMessage();
      setMsg(msg, 'err');
      setConfigAlert(msg);
      updateCanvasStatus();
      return;
    }
    if (!state.color) {
      setConfigAlert('Kies eerst een railkleur om verder te gaan.');
      return;
    }
    if (!state.powerKey) {
      setConfigAlert('Kies eerst het stroompunt voordat u de complete set kunt toevoegen.');
      return;
    }
    if (!state.measureMode) {
      setConfigAlert('Kies eerst of u hartmaten of railmaten wilt gebruiken.');
      return;
    }
    if (state.segmentLenCm.size !== state.segments.length) {
      setConfigAlert('Vul eerst alle rechte railmaten in voordat u de complete set kunt toevoegen.');
      return;
    }

    clearConfigAlert();
    setDisabledAll(el.btnAddCart, true);
    setTextAll(el.btnAddCart, 'Bezig…');

    try {
      if (!state.designCode) {
        const saved = await saveDesignOnServer();
        setDesignCode(saved.code);
      }

      await trackRailcfgEvent('add_to_cart_click', { designCode: state.designCode || null });

      const pack = partsToCartItems();
      if (!pack.ok) throw new Error(pack.reason || 'Geen onderdelen om toe te voegen.');

      const configItems = pack.items.slice();
      pruneAccessorySelectionsToActiveColor();
      saveAccessorySelections();
      const accessoryItems = getAccessoryCartItems();
      const spotItems = getSpotCartItems();
      const items = [
        ...spotItems,
        ...accessoryItems
      ];
      if (state.railMode === 'self') {
        items.push({ id: BUILDTOOL_VARIANT_ID, quantity: 1 });
      }
      items.push(...configItems);

      await addToCart(items);

      if (state.designCode) {
        await setCartAttributes({ Ontwerpcode: state.designCode, Railbewerking: railModeLabel(state.railMode) });
      }

      const accessoryMsg = accessoryItems.length ? ` Inclusief ${accessoryItems.length} accessoireregel${accessoryItems.length === 1 ? '' : 's'}.` : '';
      const spotMsg = spotItems.length ? ` Inclusief ${spotItems.length} spotregel${spotItems.length === 1 ? '' : 's'}.` : '';
      const railModeMsg = state.railMode === 'self' ? ' Inclusief Global buigtool XTSV12.' : '';
      setMsg(`Onderdelen zijn toegevoegd aan uw winkelmand. Ontwerpcode: ${state.designCode || '—'}.${accessoryMsg}${spotMsg}${railModeMsg}`, 'ok');

      window.setTimeout(() => {
        window.location.href = '/cart';
      }, 450);
      return;

    } catch (err) {
      setMsg(err?.message || 'Toevoegen mislukt. Probeer opnieuw of neem contact op.', 'err');
      restoreDefaultText(el.btnAddCart);
      setDisabledAll(el.btnAddCart, false);
      console.error(err);
    }
  }

  el.btnAddCart.forEach((b) => b.addEventListener('click', handleAddCartClick));

  // ---------------------------
  // Export PDF (download via Worker /export-pdf)
  // ---------------------------
  if (el.btnExportPdf) {
    el.btnExportPdf.addEventListener('click', async () => {
      try {
        if (hasRailValidationError()) throw new Error(getRailValidationMessage());
        if (!state.segments.length) throw new Error('Teken eerst een railvorm.');
        if (!state.color) throw new Error('Kies eerst een railkleur voordat u de installatietekening downloadt.');
        if (!state.powerKey) throw new Error('Kies eerst het stroompunt voordat u de installatietekening downloadt.');
        if (!state.measureMode) throw new Error('Kies eerst of u hartmaten of railmaten wilt gebruiken.');
        if (state.segmentLenCm.size !== state.segments.length) throw new Error('Vul eerst alle rechte railmaten in voordat u de installatietekening downloadt.');
        if (!WORKER_BASE) throw new Error('Worker URL ontbreekt (section setting).');

        clearConfigAlert();
        el.btnExportPdf.disabled = true;
        const oldText = el.btnExportPdf.dataset.defaultLabel || el.btnExportPdf.textContent;
        el.btnExportPdf.textContent = 'PDF maken…';

        if (!state.designCode) {
          setDesignMsg('Ontwerpcode wordt aangemaakt…', 'ok');
          const saved = await saveDesignOnServer();
          setDesignCode(saved.code);
        }

        trackRailcfgEvent('pdf_click');

        const segLenObj = {};
        for (const [k, v] of state.segmentLenCm.entries()) segLenObj[k] = v;

        const centerLenObj = {};
        for (const [k, v] of state.centerLenCm.entries()) centerLenObj[k] = v;

        const payload = {
          color: state.color,
          powerKey: state.powerKey,
          segments: state.segments,
          measureMode: state.measureMode,
          segmentLenCm: segLenObj,
          centerLenCm: centerLenObj,
          designCode: state.designCode || null,
          addStrips: false,
          spotSelections: buildSpotSelectionsObject(),
          spotConfig: buildSpotConfigObject(),
          spotItems: buildSpotItemsForPdf()
        };

        const res = await fetch(WORKER_BASE + '/export-pdf', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!res.ok) {
          const out = await res.json().catch(() => ({}));
          throw new Error(out?.reason || `Export mislukt (${res.status}).`);
        }

        const blob = await res.blob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'railspot-installatietekening.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.setTimeout(() => URL.revokeObjectURL(url), 1500);
        setDesignMsg(`Installatietekening gedownload. Ontwerpcode: ${state.designCode || '—'}.`, 'ok');
        el.btnExportPdf.textContent = oldText;
        el.btnExportPdf.disabled = false;

      } catch (e) {
        if (el.btnExportPdf) {
          el.btnExportPdf.disabled = false;
          el.btnExportPdf.textContent = el.btnExportPdf.dataset.defaultLabel || 'PDF';
        }
        setConfigAlert(e?.message || 'Export mislukt.');
      }
    });
  }

  // ---------------------------
  // Color buttons
  // ---------------------------
  function setColor(next) {
    if (!(next in VARIANTS)) return;
    const prev = state.color;
    state.color = next;
    setDesignCode(null);

    if (prev && prev !== next) {
      state.spotQtyByVariant.clear();
      state.accessoryQtyByVariant.clear();
      saveAccessorySelections();
    }

    el.colorBtns.forEach(b => b.classList.toggle('is-active', b.getAttribute('data-color') === next));
    updateColorIndicatorPill();

    if (!hasRailValidationError()) clearConfigAlert();
    render();
  }
  el.colorBtns.forEach(b => b.addEventListener('click', () => setColor(b.getAttribute('data-color'))));

  // ---------------------------
  // Bindings (multi buttons)
  // ---------------------------
  el.svg.addEventListener('pointerdown', onPointerDown);
  el.svg.addEventListener('pointermove', onPointerMove);

  el.btnUndo.forEach((b) => b.addEventListener('click', undo));
  el.btnClear.forEach((b) => b.addEventListener('click', clearAll));

  bindPress(el.btnLocks, () => {
    state.isLocked = !state.isLocked;
    if (state.isLocked) {
      drawing.active = false;
      drawing.start = null;
      stopPreview();
      state.pickPowerMode = false;
    }
    render();
  });

  bindPress(el.btnFinishDraw, () => {
    finishDrawingAndAdvance();
  });

  el.btnPickPower.forEach((b) => b.addEventListener('click', () => {
    if (!state.segments.length) return;
    state.pickPowerMode = true;
    render();
    window.setTimeout(() => {
      scrollToDrawStep();
    }, 60);
  }));

el.btnClearPower.forEach((b) => b.addEventListener('click', () => {
  state.powerKey = null;
  state.pickPowerMode = false;
  rebuildPoints();
  setDesignCode(null);
  render();
}));

  if (el.measureModeRadios && el.measureModeRadios.length) {
    el.measureModeRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        setMeasureMode(radio.value);
      });
    });
  }

  if (el.railModeRadios && el.railModeRadios.length) {
    el.railModeRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        setRailMode(radio.value);
      });
    });
  }

  if (el.btnLoadDesign) {
    el.btnLoadDesign.addEventListener('click', handleManualLoadDesign);
  }

  if (el.btnSaveDesign) {
    el.btnSaveDesign.addEventListener('click', handleSaveDesignOnly);
  }

  if (el.designCodeInput) {
    el.designCodeInput.addEventListener('input', () => {
      const normalized = normalizeDesignCode(el.designCodeInput.value);
      if (el.designCodeInput.value !== normalized) {
        el.designCodeInput.value = normalized;
      }
    });

    el.designCodeInput.addEventListener('keydown', (evt) => {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        handleManualLoadDesign();
      }
    });
  }

  // E-mail ontwerp knop binding
  if (el.btnShareLink) {
    el.btnShareLink.addEventListener('click', async () => {
      if (!state.segments.length) {
        setDesignMsg('Teken eerst een ontwerp om per e-mail te kunnen versturen.', 'err');
        return;
      }

      try {
        el.btnShareLink.disabled = true;
        el.btnShareLink.textContent = 'E-mail maken…';
        await emailDesignLink();
        trackRailcfgEvent('email_link_click');
      } catch (err) {
        setDesignMsg(err?.message || 'E-mail link maken mislukt.', 'err');
      } finally {
        el.btnShareLink.disabled = false;
        el.btnShareLink.textContent = el.btnShareLink.dataset.defaultLabel || 'E-mail link';
      }
    });
  }

  if (el.btnOffer) {
    if (!el.btnOffer.dataset.defaultLabel) {
      el.btnOffer.dataset.defaultLabel = (el.btnOffer.textContent || '').trim();
    }

    el.btnOffer.addEventListener('click', async () => {
      const shouldOpen = !el.offerPanel || el.offerPanel.hidden;
      if (!shouldOpen) {
        setOfferPanelOpen(false);
        setOfferFormMsg('', 'ok');
        return;
      }

      try {
        el.btnOffer.disabled = true;
        el.btnOffer.textContent = 'Laden…';
        await ensureOfferDesignCode();
        trackRailcfgEvent('offer_open_click');
        setOfferPanelOpen(true);
      } catch (err) {
        setOfferPanelOpen(true);
        setOfferFormMsg(err?.message || 'Offerteformulier openen mislukt.', 'err');
      } finally {
        el.btnOffer.disabled = false;
        el.btnOffer.textContent = el.btnOffer.dataset.defaultLabel || 'Offerte / informatieaanvraag railontwerp';
      }
    });
  }

  // Belangrijk: Shopify contactform moet native submitten voor hCaptcha.
  // Daarom geen JS submit-intercept; we zorgen alleen dat de ontwerpcode
  // al wordt aangemaakt wanneer het formulier geopend wordt.

  if (el.cutPlanToggle) {
    el.cutPlanToggle.addEventListener('click', () => {
      state.cutPlanOpen = !state.cutPlanOpen;
      updateCutPlanToggleUI();
    });
  }

  bindSpotCarousel();
  bindAccessoryCarousel();

  if (el.addStrips) {
    el.addStrips.checked = !!state.addStrips;
    el.addStrips.addEventListener('change', () => {
      state.addStrips = !!el.addStrips.checked;
      setDesignCode(null);
      render();
    });
  }

  // ---------------------------
  // Init
  // ---------------------------
  updateColorUI();
  setDesignCode(null);
  loadAccessorySelections();

  (async () => {
    try {
      const loadedDesign = await tryLoadDesignFromUrl();
      if (!loadedDesign) {
        const loadedCfg = tryLoadCfgFromUrl();
        if (!loadedCfg) {
          const restored = loadAutosave();
          if (restored) setDesignMsg('Uw vorige ontwerp is automatisch hersteld.', 'ok');
        }
      }
    } catch (e) {
      setDesignMsg(e?.message || 'Kon opgeslagen ontwerp niet laden.', 'err');
    }
    if (el.addStrips) el.addStrips.checked = !!state.addStrips;
    render();
  })();
})();
